<template>
  <div :class="load ? 'd-flex' : ''">
    <div class="pt-2" v-show="!load">
      <!-- Sensor Selector (fora do v-if info para funcionar com sensores "em breve") -->
      <div class="na-sensor-select" v-if="sensorList.length > 0">
        <span class="na-label">Selecione o sensor para visualização</span>
        <!-- Dropdown customizado (com ícone por sensor; o <select> nativo não permite ícone). -->
        <div class="na-sensor-dropdown mt-1" :class="{ open: sensorDropdownOpen }">
          <!-- backdrop invisível: fecha ao clicar fora -->
          <div v-if="sensorDropdownOpen" class="na-sensor-backdrop" @click="sensorDropdownOpen = false"></div>
          <button type="button" class="na-sensor-trigger" @click="toggleSensorDropdown">
            <span class="na-sensor-trigger-content">
              <MaskIcon
                v-if="sensorIcon(sensorList[selectedSensorIndex] && sensorList[selectedSensorIndex].linkname)"
                :src="sensorIcon(sensorList[selectedSensorIndex] && sensorList[selectedSensorIndex].linkname)"
                color="#393939"
                :size="20"
                class="na-sensor-opt-icon"
              />
              <span>{{ sensorList[selectedSensorIndex] && sensorList[selectedSensorIndex].nome }}</span>
            </span>
            <i class="fa fa-chevron-down na-sensor-chevron"></i>
          </button>
          <ul class="na-sensor-options" v-if="sensorDropdownOpen">
            <li
              v-for="(sensor, index) in sensorList"
              :key="index"
              class="na-sensor-option"
              :class="{ selected: index === selectedSensorIndex }"
              @click="selectSensor(index)"
            >
              <MaskIcon
                v-if="sensorIcon(sensor.linkname)"
                :src="sensorIcon(sensor.linkname)"
                color="#393939"
                :size="20"
                class="na-sensor-opt-icon"
              />
              <span class="na-sensor-opt-icon na-sensor-opt-icon--empty" v-else></span>
              <span>{{ sensor.nome }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Sensores em breve (fora do v-if info) -->
      <div class="na-section na-coming-soon-card"
        v-if="!info && isComingSoonSensor">
        <div class="na-coming-soon-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.5-13H13v6l5.25 3.15-.75 1.23L11.5 14V7z" fill="#B0BEC5"/>
          </svg>
        </div>
        <span class="na-coming-soon-title">Em breve</span>
        <span class="na-coming-soon-text">A visualização deste sensor estará disponível em breve. Os dados estão sendo coletados normalmente.</span>
      </div>

      <div v-if="info">

        <!-- Premium upsell (substitui o conteúdo quando não-premium) -->
        <div v-if="premium === false && !isComingSoonSensor" class="na-premium-wrapper">
          <a href="https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=2c938084928a58930192906bd3df01e7" class="na-premium-link">
            <img
              src="../../../public/img/AssinarPlano.png"
              alt="AssinarPlano"
            />
          </a>
        </div>

        <!-- Conteúdo principal: só renderiza quando é premium (ou quando premium=null/coming soon) -->
        <template v-if="premium !== false || isComingSoonSensor">
        <!-- Histórico de leitura header -->
        <div class="na-historico-header">
          <span class="na-historico-title">Histórico de leitura</span>
          <div class="na-sensor-icons" v-if="!isPublicOnly">
            <div class="na-battery-wrapper" v-if="(station.linkname === 'estacao' && hour) || bateriaOnConnect" @mouseenter="showBatteryTooltip = true" @mouseleave="showBatteryTooltip = false">
              <img
                v-if="station.linkname === 'estacao' && hour"
                src="..\mapa\src\components\mapa\stationIcon\Estacao.svg"
                style="height: 18px; filter: brightness(0);"
              />
              <img
                v-if="station.linkname === 'estacao' && currentBattery === 1"
                src="..\mapa\src\components\mapa\stationIcon\StationBatteryFull.svg"
                style="height: 28px;"
              />
              <img
                v-else-if="station.linkname === 'estacao' && currentBattery === 0"
                src="..\mapa\src\components\mapa\stationIcon\StationBatteryLow.svg"
                style="height: 28px;"
              />
              <img
                v-if="bateriaOnConnect"
                src="..\mapa\src\components\mapa\stationIcon\onConnectIcon.svg"
                style="height: 22px; margin-left: 4px; filter: brightness(0);"
              />
              <div v-if="bateriaOnConnect" class="na-onconnect-battery-icon na-onconnect-battery-icon--header">
                <svg width="100%" height="100%" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <clipPath id="batteryClipHeader">
                      <rect x="1.81" y="1.81" width="19.15" height="8.23" rx="0.5" />
                    </clipPath>
                  </defs>
                  <rect x="1.81" y="1.81" :width="19.15 * onConnectBatteryRound / 100" height="8.23" :fill="onConnectBatteryColor" clip-path="url(#batteryClipHeader)" />
                  <path d="M20.8564 10.0423C20.9119 10.0423 20.9573 9.9969 20.9573 9.94144L20.9573 1.9081C20.9573 1.85264 20.9119 1.80722 20.8564 1.80722L1.9082 1.80722C1.85273 1.80722 1.80731 1.85264 1.80731 1.9081L1.80731 9.94144C1.80731 9.9969 1.85273 10.0423 1.9082 10.0423L20.8564 10.0423ZM1.9082 11.8495C0.854438 11.8495 9.30213e-05 10.9952 9.30633e-05 9.94144L9.33839e-05 1.9081C9.3426e-05 0.854342 0.854439 -1.04893e-06 1.9082 -9.98487e-07L20.8564 -9.13494e-08C21.9102 -4.09014e-08 22.7645 0.854342 22.7645 1.9081L22.7645 9.94144C22.7645 10.9952 21.9102 11.8495 20.8564 11.8495L1.9082 11.8495Z" fill="currentColor"/>
                  <rect x="24" y="2.41406" width="7.02946" height="2.00842" rx="0.502104" transform="rotate(90 24 2.41406)" fill="currentColor" />
                </svg>
                <span class="na-onconnect-battery-text">{{ onConnectBatteryRound }}</span>
              </div>
              <!-- Tooltip -->
              <div class="na-battery-tooltip" v-if="showBatteryTooltip">
                <!-- Estação block -->
                <div class="na-btt-block" v-if="station.linkname === 'estacao' && hour">
                  <div class="na-btt-icons-row">
                    <img src="..\mapa\src\components\mapa\stationIcon\Estacao.svg" class="na-btt-icon" />
                    <svg v-if="currentBattery === 1" class="na-btt-battery" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M6.04761 11.5654C5.24191 12.9038 6.29194 14.5484 7.95288 14.5488H8.70874L8.79272 17.2432H1.76636V6.64844H9.0105L6.04761 11.5654ZM21.1902 17.2432H14.0066L16.7615 12.4795C17.5346 11.1418 16.4825 9.52637 14.8376 9.52637H14.1111V6.64844H21.1902V17.2432Z" fill="#10C537"/>
                      <path d="M8.24609 7.91699H1.9082C1.85293 7.91707 1.80782 7.96234 1.80762 8.01758V16.0518C1.80783 16.107 1.85293 16.1523 1.9082 16.1523H8.75879L8.81543 17.96H1.9082C0.854628 17.9599 0.000206239 17.1053 0 16.0518V8.01758C0.000203427 6.96403 0.854626 6.10945 1.9082 6.10938H9.33594L8.24609 7.91699ZM20.8564 6.10938C21.9101 6.10938 22.7644 6.96398 22.7646 8.01758V8.52344H23.498C23.7753 8.52344 24.0009 8.74819 24.001 9.02539V15.0508C24.001 15.3281 23.7754 15.5527 23.498 15.5527H22.7646V16.0518C22.7644 17.1054 21.9101 17.96 20.8564 17.96H13.5918L14.6377 16.1523H20.8564C20.9118 16.1523 20.9578 16.107 20.958 16.0518V8.01758C20.9578 7.96229 20.9118 7.91699 20.8564 7.91699H14.1104V6.10938H20.8564Z" fill="#FFFFFF"/>
                      <path d="M12.5019 10.5315V5.77164C12.5019 5.26553 11.8379 5.07735 11.5723 5.50819L7.4008 12.2765C7.19461 12.611 7.43527 13.042 7.82824 13.042H9.78634C10.0574 13.042 10.2796 13.2572 10.2882 13.5281L10.4418 18.35C10.4578 18.8522 11.1199 19.0221 11.3758 18.5896L15.3974 11.7913C15.5954 11.4566 15.3541 11.0336 14.9652 11.0336H13.004C12.7267 11.0336 12.5019 10.8088 12.5019 10.5315Z" fill="#10C537"/>
                    </svg>
                    <svg v-else class="na-btt-battery" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.7334 7.88281H1.9082C1.85286 7.88282 1.8078 7.9281 1.80762 7.9834V16.0166C1.80762 16.0721 1.85274 16.1182 1.9082 16.1182H3.41699C3.43516 16.899 3.91917 17.622 4.6543 17.9248H1.9082C0.854449 17.9248 -4.20558e-08 17.0704 0 16.0166V7.9834C0.000184182 6.9298 0.854563 6.0752 1.9082 6.0752H8.75L7.7334 7.88281ZM20.8564 6.0752C21.9101 6.0752 22.7645 6.9298 22.7646 7.9834V8.48926H23.498C23.7753 8.48926 23.9999 8.71399 24 8.99121V15.0166C24 15.2939 23.7754 15.5186 23.498 15.5186H22.7646V16.0166C22.7646 17.0704 21.9102 17.9248 20.8564 17.9248H17.3457C18.0808 17.622 18.5648 16.899 18.583 16.1182H20.8564C20.9119 16.1182 20.957 16.0721 20.957 16.0166V7.9834C20.9568 7.9281 20.9118 7.88282 20.8564 7.88281H14.2666L13.25 6.0752H20.8564Z" fill="#FFFFFF"/>
                      <path d="M11.7779 6.7835C12.0195 6.92275 12.2198 7.12431 12.3582 7.3674L16.5427 14.7165C16.6792 14.9562 16.7507 15.2278 16.75 15.504C16.7493 15.7803 16.6764 16.0515 16.5387 16.2904C16.4009 16.5294 16.2031 16.7277 15.9652 16.8654C15.7272 17.0032 15.4575 17.0755 15.183 17.0752H6.81598C6.54156 17.0753 6.27194 17.0028 6.03414 16.865C5.79633 16.7272 5.59871 16.5289 5.46109 16.29C5.32346 16.051 5.25067 15.7799 5.25 15.5037C5.24934 15.2276 5.32083 14.9561 5.45731 14.7165L9.64185 7.3674C9.8482 7.00492 10.1892 6.73978 10.5897 6.63028C10.9903 6.52078 11.4177 6.57589 11.7779 6.7835ZM11.0016 13.9247C10.8632 13.9247 10.7305 13.98 10.6326 14.0785C10.5348 14.1769 10.4798 14.3105 10.4798 14.4498C10.4798 14.589 10.5348 14.7226 10.6326 14.8211C10.7305 14.9195 10.8632 14.9749 11.0016 14.9749C11.1399 14.9749 11.2727 14.9195 11.3705 14.8211C11.4684 14.7226 11.5233 14.589 11.5233 14.4498C11.5233 14.3105 11.4684 14.1769 11.3705 14.0785C11.2727 13.98 11.1399 13.9247 11.0016 13.9247ZM10.9995 8.67381C10.8611 8.67381 10.7284 8.72914 10.6305 8.82761C10.5327 8.92608 10.4777 9.05964 10.4777 9.1989V12.3494L10.4861 12.4439C10.5093 12.5731 10.5797 12.6887 10.6835 12.7682C10.7872 12.8477 10.9168 12.8852 11.0466 12.8733C11.1765 12.8615 11.2972 12.8011 11.3851 12.7042C11.4729 12.6072 11.5215 12.4806 11.5212 12.3494V9.1989L11.5129 9.10438C11.4909 8.98349 11.4275 8.87419 11.3337 8.79552C11.2399 8.71684 11.1216 8.67377 10.9995 8.67381Z" fill="#FF3E3E"/>
                    </svg>
                  </div>
                  <span class="na-btt-label">Estação: Bateria {{ currentBattery === 1 ? 'OK' : 'Baixa' }}</span>
                </div>
                <!-- OnConnect block -->
                <div class="na-btt-block" v-if="bateriaOnConnect">
                  <div class="na-btt-icons-row">
                    <img src="..\mapa\src\components\mapa\stationIcon\onConnectIcon.svg" class="na-btt-icon na-btt-icon-white" />
                    <div class="na-onconnect-battery-icon na-onconnect-battery-icon--tooltip">
                      <svg width="100%" height="100%" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <clipPath id="batteryClipTooltip">
                            <rect x="1.81" y="1.81" width="19.15" height="8.23" rx="0.5" />
                          </clipPath>
                        </defs>
                        <rect x="1.81" y="1.81" :width="19.15 * onConnectBatteryRound / 100" height="8.23" :fill="onConnectBatteryColor" clip-path="url(#batteryClipTooltip)" />
                        <path d="M20.8564 10.0423C20.9119 10.0423 20.9573 9.9969 20.9573 9.94144L20.9573 1.9081C20.9573 1.85264 20.9119 1.80722 20.8564 1.80722L1.9082 1.80722C1.85273 1.80722 1.80731 1.85264 1.80731 1.9081L1.80731 9.94144C1.80731 9.9969 1.85273 10.0423 1.9082 10.0423L20.8564 10.0423ZM1.9082 11.8495C0.854438 11.8495 9.30213e-05 10.9952 9.30633e-05 9.94144L9.33839e-05 1.9081C9.3426e-05 0.854342 0.854439 -1.04893e-06 1.9082 -9.98487e-07L20.8564 -9.13494e-08C21.9102 -4.09014e-08 22.7645 0.854342 22.7645 1.9081L22.7645 9.94144C22.7645 10.9952 21.9102 11.8495 20.8564 11.8495L1.9082 11.8495Z" fill="#FFFFFF"/>
                        <rect x="24" y="2.41406" width="7.02946" height="2.00842" rx="0.502104" transform="rotate(90 24 2.41406)" fill="#FFFFFF" />
                      </svg>
                      <span class="na-onconnect-battery-text">{{ onConnectBatteryRound }}</span>
                    </div>
                  </div>
                  <span class="na-btt-label">OnConnect: {{ onConnectBatteryPercentage }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Day items + expanded content connected -->
        <div class="na-days-container" v-if="!isComingSoonSensor">
          <div class="na-days-row">
            <NewAsideDayItem
              v-for="(d, i) in displayDays"
              :key="d.originalIndex"
              :dayData="d.day"
              :index="d.originalIndex"
              :isActive="expandedDayIndex === d.originalIndex"
              :stationType="station.linkname"
              :isCurrentDay="i === displayDays.length - 1"
              @select="onDaySelect"
            />
          </div>

          <!-- EXPANDED DAY CONTENT -->
          <div v-if="expandedDayIndex !== null && hour" class="na-expanded-content" :style="expandedContentRadius">

          <!-- Leitura atual -->
          <div class="na-section na-leitura" v-if="['estacao', 'solo', 'folhar', 'ambiente', 'lut', 'fotobio', 'ritter'].includes(station.linkname) || sondaLinknames.includes(station.linkname)">
            <div class="na-leitura-row">
              <span class="na-leitura-label">Leitura atual</span>
              <span class="na-leitura-date">{{ formatDate(hour.dateTimeLeitura || hour.dateTime) }}</span>
              <span class="na-leitura-time">{{ formatTime(hour.dateTimeLeitura || hour.dateTime) }}</span>
            </div>
          </div>

          <!-- Logo enAgro (entre leitura e o conteúdo do sensor, estação e LUT) -->
          <div v-if="station.linkname === 'estacao' || station.linkname === 'lut'" class="na-estacao-logo-row">
            <img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" class="na-estacao-logo" alt="OnAgro" />
          </div>

          <!-- Astronomia -->
          <div class="na-section na-astronomia" v-if="currentDayAstronomia">
            <div class="na-astro-label">Astronomia</div>
            <div class="na-astro-row">
              <div class="na-astro-item">
                <div class="na-astro-sun"></div>
                <div class="na-astro-info">
                  <b>Sol</b>
                  <span>nasce / {{ currentDayAstronomia.solNasce || '--' }}</span>
                  <span>poe / {{ currentDayAstronomia.solPoe || '--' }}</span>
                </div>
              </div>
              <div class="na-astro-item">
                <img v-if="luaFaseIcon" :src="luaFaseIcon" class="na-astro-moon" alt="Fase da lua" />
                <div v-else class="na-astro-moon"></div>
                <div class="na-astro-info">
                  <b>Lua</b>
                  <span>{{ luaFaseLabel }}</span>
                  <span>nasce / {{ currentDayAstronomia.luaNasce || '--' }}</span>
                  <span>poe / {{ currentDayAstronomia.luaPoe || '--' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Temperatura -->
          <div :class="['na-section', 'na-temp-card', 'na-clickable', { 'na-card-selected': selectedCardKey === 'temperatura' }]"
            v-if="station.linkname === 'estacao'"
            @click="selectCard('temperatura', 'temperature')">
            <div class="na-temp-header">
              <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
              <span>Temperatura</span>
            </div>
            <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(${getTemperatureColor()}, 0.12) 0%, rgba(255,255,255,0) 60%)` }">
              <div class="na-temp-left">
                <span class="na-temp-value">{{ hour.temperature?.toFixed(2) || '--' }}<sup>°</sup>c</span>
              </div>
              <div class="na-temp-mid">
                <span class="na-temp-info-label">máxima</span>
                <b class="na-temp-info-value">{{ currentDayResume.temperatureMax?.toFixed(2) || '--' }}°c</b>
                <span class="na-temp-info-label">mínima</span>
                <span class="na-temp-info-value">{{ currentDayResume.temperatureMin?.toFixed(2) || '--' }}°c</span>
              </div>
              <div class="na-temp-right">
                <span class="na-temp-info-label na-temp-umidade-label">
                  <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-14" alt="umidade" />
                  umidade
                </span>
                <b class="na-temp-info-value">{{ hour.humidity || '--' }}%</b>
                <span class="na-temp-info-label">sensação</span>
                <span class="na-temp-info-value">{{ calcSensacao() }}°c</span>
              </div>
            </div>
          </div>
          <!-- Chart/Table after Temperatura if selected -->
          <div v-if="selectedCardKey === 'temperatura'" class="na-chart-table-card">
            <div class="na-wind-tabs">
              <button :class="['na-wind-tab', { active: tempTab === 'temperature' }]" @click="switchTempTab('temperature')">Temperatura</button>
              <button :class="['na-wind-tab', { active: tempTab === 'humidity' }]" @click="switchTempTab('humidity')">Umidade</button>
            </div>
            <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
            <template v-else-if="statsHours.length">
              <NewAsideHistoryChart :hours="tempTabChartData" :metricField="'avg'" :showMinMax="true" :metricLabel="tempTab === 'temperature' ? 'Temperatura (°C)' : 'Umidade (%)'" :metricColor="tempTab === 'temperature' ? '#F49C18' : '#3E97FF'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
              <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
              <NewAsideDataTable :hours="statsHours" :columns="tempTabTableColumns" />
            </template>
          </div>

          <!-- Sondas (agrupadas por sourceId) -->
          <template v-if="sondaLinknames.includes(station.linkname)">
            <template v-for="sensor in sondaSensors" :key="sensor.sourceId">
            <div
              :class="['na-section', 'na-temp-card', 'na-clickable', { 'na-card-selected': selectedCardKey === 'sonda-' + sensor.sourceId }]"
              @click="selectSondaCard(sensor.sourceId)">

              <!-- Hidro card -->
              <template v-if="station.linkname === 'sonda-hidrostatica'">
                <div class="na-sonda-badge-row" v-if="sondaSensors.length > 1">
                  <span class="na-sonda-badge" style="background: #00A8F0;">{{ formatSourceId(sensor.sourceId) }}</span>
                </div>
                <div class="na-temp-header">
                  <img src="..\mapa\src\components\mapa\stationIcon\NivelLiquidoBlack.svg" class="na-icon-20" alt="profundidade" />
                  <span>Profundidade</span>
                </div>
                <div class="na-temp-body" :style="{ background: 'linear-gradient(90deg, rgba(0, 168, 240, 0.12) 0%, rgba(255,255,255,0) 60%)' }">
                  <div class="na-temp-left">
                    <span class="na-temp-value">{{ sondaLastHour(sensor)?.depthCalc?.toFixed(2) || '--' }}<small style="font-size: 28px; font-weight: 500; color: #666;">m</small></span>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">máxima</span>
                    <b class="na-temp-info-value">{{ currentDayResume.depthMax?.toFixed(2) || '--' }}m</b>
                    <span class="na-temp-info-label">mínima</span>
                    <span class="na-temp-info-value">{{ currentDayResume.depthMin?.toFixed(2) || '--' }}m</span>
                  </div>
                </div>
                <div class="na-sonda-logo-row">
                  <img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" class="na-sonda-logo" alt="OnAgro" />
                </div>
                <div class="na-nivel-image-wrapper">
                  <img src="..\mapa\src\components\mapa\stationIcon\HidroSensorPoco3D.png" class="na-nivel-image" alt="sensor hidro" />
                </div>
                <div class="na-nivel-transbordo-row">
                  <div class="na-nivel-transbordo-badge">
                    <span class="na-nivel-transbordo-x">X</span> = referência de instalação <b>{{ (sondaLastHour(sensor)?.offset || sondaLastHour(sensor)?.maxReached)?.toFixed(2) || '--' }} m</b>
                  </div>
                </div>
              </template>

              <!-- Laser card -->
              <template v-else-if="station.linkname === 'sonda-laser'">
                <div class="na-sonda-badge-row">
                  <span class="na-sonda-badge" style="background: #8B00C8;">{{ formatSourceId(sensor.sourceId) }}</span>
                </div>
                <div class="na-temp-header" v-if="sondaLastHour(sensor)?.temperature != null">
                  <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                  <span>Temperatura</span>
                </div>
                <div class="na-temp-body" v-if="sondaLastHour(sensor)?.temperature != null" :style="{ background: 'linear-gradient(90deg, rgba(249, 134, 1, 0.10) 0%, rgba(255,255,255,0) 60%)' }">
                  <div class="na-temp-left">
                    <span class="na-temp-value">{{ sondaLastHour(sensor)?.temperature?.toFixed(2) || '--' }}<sup>°</sup>c</span>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">máxima</span>
                    <b class="na-temp-info-value">{{ currentDayResume.temperatureMax?.toFixed(2) || '--' }}°c</b>
                    <span class="na-temp-info-label">mínima</span>
                    <span class="na-temp-info-value">{{ currentDayResume.temperatureMin?.toFixed(2) || '--' }}°c</span>
                  </div>
                </div>
                <div class="na-temp-header" style="margin-top: 8px;">
                  <img src="..\mapa\src\components\mapa\stationIcon\NivelLiquidoBlack.svg" class="na-icon-20" alt="nivel" />
                  <span>Profundidade</span>
                </div>
                <div class="na-temp-body" :style="{ background: 'linear-gradient(90deg, rgba(139, 0, 200, 0.08) 0%, rgba(255,255,255,0) 60%)' }">
                  <div class="na-temp-left">
                    <span class="na-temp-value">{{ sondaLastHour(sensor)?.depthCalc?.toFixed(2) || '--' }}<small style="font-size: 28px; font-weight: 500; color: #666;">m</small></span>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">máxima</span>
                    <b class="na-temp-info-value">{{ currentDayResume.depthMax?.toFixed(2) || '--' }}m</b>
                    <span class="na-temp-info-label">mínima</span>
                    <span class="na-temp-info-value">{{ currentDayResume.depthMin?.toFixed(2) || '--' }}m</span>
                  </div>
                </div>
                <div class="na-sonda-logo-row">
                  <img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" class="na-sonda-logo" alt="OnAgro" />
                </div>
                <div class="na-laser-details" v-if="sondaLastHour(sensor)?.diametro != null || sondaLastHour(sensor)?.lado1 != null">
                  <span v-if="sondaLastHour(sensor)?.diametro != null">diâmetro <b>{{ sondaLastHour(sensor)?.diametro?.toFixed(2) }}m</b></span>
                  <span v-if="sondaLastHour(sensor)?.lado1 != null">lado 1 <b>{{ sondaLastHour(sensor)?.lado1?.toFixed(2) }}m</b></span>
                  <span v-if="sondaLastHour(sensor)?.lado2 != null">lado 2 <b>{{ sondaLastHour(sensor)?.lado2?.toFixed(2) }}m</b></span>
                </div>
              </template>

              <!-- Nivel card -->
              <template v-else-if="station.linkname === 'sonda-nivel'">
                <div class="na-sonda-badge-row" v-if="sondaSensors.length > 1">
                  <span class="na-sonda-badge" style="background: #00A8F0;">{{ formatSourceId(sensor.sourceId) }}</span>
                </div>
                <div class="na-temp-header">
                  <img src="..\mapa\src\components\mapa\stationIcon\NivelLiquidoBlack.svg" class="na-icon-20" alt="profundidade" />
                  <span>Profundidade</span>
                </div>
                <div class="na-temp-body" :style="{ background: 'linear-gradient(90deg, rgba(0, 168, 240, 0.12) 0%, rgba(255,255,255,0) 60%)' }">
                  <div class="na-temp-left">
                    <span class="na-temp-value">{{ sondaLastHour(sensor)?.depthCalc?.toFixed(2) || '--' }}<small style="font-size: 28px; font-weight: 500; color: #666;">m</small></span>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">máxima</span>
                    <b class="na-temp-info-value">{{ currentDayResume.depthMax?.toFixed(2) || '--' }}m</b>
                    <span class="na-temp-info-label">mínima</span>
                    <span class="na-temp-info-value">{{ currentDayResume.depthMin?.toFixed(2) || '--' }}m</span>
                  </div>
                </div>
                <div class="na-sonda-logo-row">
                  <img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" class="na-sonda-logo" alt="OnAgro" />
                </div>
                <div class="na-nivel-image-wrapper">
                  <img src="..\mapa\src\components\mapa\stationIcon\NivelSensor3D.png" class="na-nivel-image" alt="sensor nivel" />
                </div>
                <div class="na-nivel-transbordo-row">
                  <div class="na-nivel-transbordo-badge">
                    <span class="na-nivel-transbordo-x">X</span> = nível de transbordo <b>{{ sondaLastHour(sensor)?.nivelTransbordo?.toFixed(2) || '--' }} m</b>
                  </div>
                </div>
              </template>

              <!-- Caixa d'água card (1a versao: copia do Nivel, ajustar arte depois) -->
              <template v-else-if="station.linkname === 'sonda-caixa'">
                <div class="na-sonda-badge-row" v-if="sondaSensors.length > 1">
                  <span class="na-sonda-badge" style="background: #00A8F0;">{{ formatSourceId(sensor.sourceId) }}</span>
                </div>
                <div class="na-temp-header">
                  <img src="..\mapa\src\components\mapa\stationIcon\NivelLiquidoBlack.svg" class="na-icon-20" alt="nivel da agua" />
                  <span>Nível</span>
                </div>

                <!-- Desenho do reservatório com a água no nível real -->
                <div class="na-caixa-desenho">
                  <WaterTank :percent="caixaCapacidade(sensor) || 0" :formato="caixaFormatoDesenho(sensor)" />
                </div>

                <!-- Profundidade / volume / capacidade -->
                <div class="na-caixa-metricas">
                  <div class="na-caixa-metrica">
                    <span class="na-caixa-metrica-label">profundidade</span>
                    <b class="na-caixa-metrica-valor">{{ sondaLastHour(sensor)?.depthCalc?.toFixed(2) ?? '--' }} <small>m</small></b>
                  </div>
                  <div class="na-caixa-metrica">
                    <span class="na-caixa-metrica-label">volume</span>
                    <b class="na-caixa-metrica-valor">{{ caixaVolume(sensor)?.toFixed(2) ?? '--' }}<small>m³</small></b>
                  </div>
                  <div class="na-caixa-metrica">
                    <span class="na-caixa-metrica-label">capacidade</span>
                    <b class="na-caixa-metrica-valor">{{ caixaCapacidade(sensor)?.toFixed(0) ?? '--' }}<small>%</small></b>
                  </div>
                </div>

                <!-- Geometria da caixa: diametro (redonda) ou lado1 x lado2 (quadrada) -->
                <div class="na-laser-details" v-if="!caixaSemGeometria(sensor)">
                  <span v-if="caixaEhRedonda(sensor)">diâmetro <b>{{ sondaLastHour(sensor)?.diametro?.toFixed(2) }}m</b></span>
                  <template v-else>
                    <span>lado 1 <b>{{ sondaLastHour(sensor)?.lado1?.toFixed(2) }}m</b></span>
                    <span>lado 2 <b>{{ sondaLastHour(sensor)?.lado2?.toFixed(2) }}m</b></span>
                  </template>
                  <span>altura <b>{{ sondaLastHour(sensor)?.altura?.toFixed(2) ?? '--' }}m</b></span>
                </div>
                <!-- Sem geometria na leitura: o desenho é ilustrativo e não há volume. -->
                <div class="na-caixa-aviso" v-else>
                  dimensões não informadas pelo sensor — desenho ilustrativo
                </div>
                <div class="na-sonda-logo-row">
                  <img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" class="na-sonda-logo" alt="OnAgro" />
                </div>
              </template>
            </div>

            <!-- Chart/Table Sonda (logo abaixo do card selecionado) -->
            <div v-if="selectedCardKey === 'sonda-' + sensor.sourceId" class="na-chart-table-card">
              <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
              <template v-else-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                <NewAsideHistoryChart :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Profundidade (m)'" :metricColor="'#495948'" :zeroBased="true" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="sensorStats.hours" :columns="sensorStatsTableColumns" />
              </template>
            </div>
            </template>
          </template>

          <!-- Sensor Solo -->
          <template v-if="station.linkname === 'solo'">
            <div v-for="(sensor, sIdx) in soilSensors" :key="sensor.sourceId"
              :class="['na-section', 'na-soil-group', 'na-clickable', { 'na-card-selected': selectedCardKey === 'solo-' + sensor.sourceId }]">
              <div class="na-soil-depth-label">
                Sensor a <b>{{ sensor.depth || '--' }} cm</b>
              </div>
              <div class="na-soil-cards-row">
                <div class="na-soil-card-half" @click="selectSoilCard(sensor.sourceId, 'temperature')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                    <span>Temperatura</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(${getSoilTemperatureColor(sensor)}, 0.12) 0%, rgba(255,255,255,0) 100%)` }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.temperature?.toFixed(2) || '--' }}<sup>°</sup>c</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'temperature')?.toFixed(2) || '--' }}°c</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'temperature')?.toFixed(2) || '--' }}°c</span>
                    </div>
                  </div>
                </div>
                <div class="na-soil-card-half" @click="selectSoilCard(sensor.sourceId, 'humidity')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-20" alt="umidade" />
                    <span>Umidade</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(1, 5, 249, 0.12) 0%, rgba(255,255,255,0) 100%)` }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.humidity?.toFixed(2) || '--' }}%</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'humidity')?.toFixed(2) || '--' }}%</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'humidity')?.toFixed(2) || '--' }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Chart/Table for selected soil sensor -->
            <div v-if="selectedCardKey && selectedCardKey.startsWith('solo-')" class="na-chart-table-card">
              <div class="na-wind-tabs">
                <button :class="['na-wind-tab', { active: soilTab === 'temperature' }]" @click="soilTab = 'temperature'">Temperatura</button>
                <button :class="['na-wind-tab', { active: soilTab === 'all' }]" @click="soilTab = 'all'">Todos</button>
                <button :class="['na-wind-tab', { active: soilTab === 'humidity' }]" @click="soilTab = 'humidity'">Umidade</button>
              </div>
              <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
              <template v-else-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                <NewAsideHistoryChart v-if="soilTab === 'all'" key="soil-all" :hours="sensorStats.hours" :metricField="'temperature'" :metricLabel="'Todos'" :metricColor="'#FF6B35'" :extraSeries="[{ field: 'temperature', label: 'Temperatura (°C)', color: '#FF6B35', accessor: h => h.temperature?.avg }, { field: 'humidity', label: 'Umidade (%)', color: '#0105F9', accessor: h => h.humidity?.avg }]" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'temperature'" key="soil-temp" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Temperatura (°C)'" :metricColor="'#FF6B35'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'humidity'" key="soil-hum" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Umidade (%)'" :metricColor="'#0105F9'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="sensorStats.hours" :columns="sensorStatsTableColumns" />
              </template>
            </div>
          </template>

          <!-- Sensor Folhar -->
          <template v-if="station.linkname === 'folhar'">
            <div v-for="(sensor, sIdx) in leafSensors" :key="sensor.sourceId"
              :class="['na-section', 'na-soil-group', 'na-clickable', { 'na-card-selected': selectedCardKey === 'folhar-' + sensor.sourceId }]">
              <div class="na-soil-depth-label">
                Sensor <b>{{ formatSourceId(sensor.sourceId) }}</b>
              </div>
              <div class="na-soil-cards-row">
                <div class="na-soil-card-half" @click="selectSensorCard('folhar', sensor.sourceId, 'temperature')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                    <span>Temperatura</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(${getSoilTemperatureColor(sensor)}, 0.12) 0%, rgba(255,255,255,0) 100%)` }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.temperature?.toFixed(2) || '--' }}<sup>°</sup>c</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'temperature')?.toFixed(2) || '--' }}°c</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'temperature')?.toFixed(2) || '--' }}°c</span>
                    </div>
                  </div>
                </div>
                <div class="na-soil-card-half" @click="selectSensorCard('folhar', sensor.sourceId, 'humidity')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-20" alt="umidade" />
                    <span>Umidade</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(1, 5, 249, 0.12) 0%, rgba(255,255,255,0) 100%)` }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.humidity?.toFixed(2) || '--' }}%</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'humidity')?.toFixed(2) || '--' }}%</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'humidity')?.toFixed(2) || '--' }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedCardKey && selectedCardKey.startsWith('folhar-')" class="na-chart-table-card">
              <div class="na-wind-tabs">
                <button :class="['na-wind-tab', { active: soilTab === 'temperature' }]" @click="soilTab = 'temperature'">Temperatura</button>
                <button :class="['na-wind-tab', { active: soilTab === 'all' }]" @click="soilTab = 'all'">Todos</button>
                <button :class="['na-wind-tab', { active: soilTab === 'humidity' }]" @click="soilTab = 'humidity'">Umidade</button>
              </div>
              <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
              <template v-else-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                <NewAsideHistoryChart v-if="soilTab === 'temperature'" key="leaf-temp" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Temperatura (°C)'" :metricColor="'#FF6B35'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'humidity'" key="leaf-hum" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Umidade (%)'" :metricColor="'#0105F9'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="sensorStats.hours" :columns="sensorStatsTableColumns" />
              </template>
            </div>
          </template>

          <!-- Sensor Ambiente -->
          <template v-if="station.linkname === 'ambiente'">
            <div v-for="(sensor, sIdx) in ambientSensors" :key="sensor.sourceId"
              :class="['na-section', 'na-soil-group', 'na-clickable', { 'na-card-selected': selectedCardKey === 'ambiente-' + sensor.sourceId }]">
              <div class="na-soil-depth-label">
                Sensor <b>{{ formatSourceId(sensor.sourceId) }}</b>
              </div>
              <div class="na-soil-cards-row">
                <div class="na-soil-card-half" @click="selectSensorCard('ambiente', sensor.sourceId, 'temperature')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                    <span>Temperatura</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(${getSoilTemperatureColor(sensor)}, 0.12) 0%, rgba(255,255,255,0) 100%)` }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.temperature?.toFixed(2) || '--' }}<sup>°</sup>c</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'temperature')?.toFixed(2) || '--' }}°c</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'temperature')?.toFixed(2) || '--' }}°c</span>
                    </div>
                  </div>
                </div>
                <!-- Umidade é opcional no ambiente: sem ela, some o card (e a sensação térmica abaixo) -->
                <div v-if="sensorHasHumidity(sensor)" class="na-soil-card-half" @click="selectSensorCard('ambiente', sensor.sourceId, 'humidity')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-20" alt="umidade" />
                    <span>Umidade</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(1, 5, 249, 0.12) 0%, rgba(255,255,255,0) 100%)` }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.humidity?.toFixed(2) || '--' }}%</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'humidity')?.toFixed(2) || '--' }}%</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'humidity')?.toFixed(2) || '--' }}%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="sensorHasHumidity(sensor)" class="na-soil-sensacao">
                sensação térmica <b>{{ calcSensacaoSensor(sensor) }}°c</b>
              </div>
            </div>
            <div v-if="selectedCardKey && selectedCardKey.startsWith('ambiente-')" class="na-chart-table-card">
              <!-- Sem umidade só existe temperatura: as abas não têm o que alternar -->
              <div v-if="selectedAmbientHasHumidity" class="na-wind-tabs">
                <button :class="['na-wind-tab', { active: soilTab === 'temperature' }]" @click="soilTab = 'temperature'">Temperatura</button>
                <button :class="['na-wind-tab', { active: soilTab === 'all' }]" @click="soilTab = 'all'">Todos</button>
                <button :class="['na-wind-tab', { active: soilTab === 'humidity' }]" @click="soilTab = 'humidity'">Umidade</button>
              </div>
              <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
              <template v-else-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                <NewAsideHistoryChart v-if="soilTab === 'temperature'" key="amb-temp" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Temperatura (°C)'" :metricColor="'#FF6B35'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'humidity'" key="amb-hum" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Umidade (%)'" :metricColor="'#0105F9'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="sensorStats.hours" :columns="sensorStatsTableColumns" />
              </template>
            </div>
          </template>

          <!-- Sensor LUT -->
          <template v-if="station.linkname === 'lut'">
            <div v-for="(sensor, sIdx) in lutSensors" :key="sensor.sourceId"
              :class="['na-section', 'na-soil-group', 'na-clickable', { 'na-card-selected': selectedCardKey === 'lut-' + sensor.sourceId }]">
              <div class="na-soil-depth-label">
                Sensor <b>{{ formatSourceId(sensor.sourceId) }}</b>
              </div>
              <!-- Lux -->
              <div class="na-soil-cards-row" @click="selectSensorCard('lut', sensor.sourceId, 'lux')">
                <div class="na-soil-card-half" style="flex: 1;">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\Luminosidade.svg" class="na-icon-20" alt="lux" />
                    <span>Lux</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: 'linear-gradient(90deg, rgba(249, 134, 1, 0.12) 0%, rgba(255,255,255,0) 100%)' }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.lux?.toFixed(0) || '--' }} lux</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'lux')?.toFixed(0) || '--' }} lux</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'lux')?.toFixed(0) || '--' }} lux</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Temperatura -->
              <div class="na-soil-cards-row" style="margin-top: 8px;" @click="selectSensorCard('lut', sensor.sourceId, 'temperature')">
                <div class="na-soil-card-half" style="flex: 1;">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                    <span>Temperatura</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: 'linear-gradient(90deg, rgba(249, 134, 1, 0.12) 0%, rgba(255,255,255,0) 100%)' }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.temperature?.toFixed(2) || '--' }}<sup>°</sup>c</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'temperature')?.toFixed(2) || '--' }}°c</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'temperature')?.toFixed(2) || '--' }}°c</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Umidade -->
              <div class="na-soil-cards-row" style="margin-top: 8px;" @click="selectSensorCard('lut', sensor.sourceId, 'humidity')">
                <div class="na-soil-card-half" style="flex: 1;">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-20" alt="umidade" />
                    <span>Umidade</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: 'linear-gradient(90deg, rgba(1, 5, 249, 0.12) 0%, rgba(255,255,255,0) 100%)' }">
                    <div class="na-temp-left">
                      <span class="na-soil-temp-value">{{ soilLastHour(sensor)?.humidity?.toFixed(2) || '--' }}%</span>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ soilMax(sensor, 'humidity')?.toFixed(2) || '--' }}%</b>
                      <span class="na-temp-info-label">mínima</span>
                      <span class="na-temp-info-value">{{ soilMin(sensor, 'humidity')?.toFixed(2) || '--' }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedCardKey && selectedCardKey.startsWith('lut-')" class="na-chart-table-card">
              <div class="na-wind-tabs">
                <button :class="['na-wind-tab', { active: soilTab === 'lux' }]" @click="soilTab = 'lux'">Lux</button>
                <button :class="['na-wind-tab', { active: soilTab === 'temperature' }]" @click="soilTab = 'temperature'">Temperatura</button>
                <button :class="['na-wind-tab', { active: soilTab === 'humidity' }]" @click="soilTab = 'humidity'">Umidade</button>
              </div>
              <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
              <template v-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                <NewAsideHistoryChart v-if="soilTab === 'lux'" key="lut-lux" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Lux (lx)'" :metricColor="'#F98601'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'temperature'" key="lut-temp" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Temperatura (°C)'" :metricColor="'#F98601'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'humidity'" key="lut-hum" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Umidade (%)'" :metricColor="'#0105F9'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="sensorStats.hours" :columns="sensorStatsTableColumns" />
              </template>
            </div>
          </template>

          <!-- Sensor Fotobio: visão geral de todos os tanques + um card por tanque ativo -->
          <template v-if="station.linkname === 'fotobio'">
            <div v-if="!fotobioTanks.length" class="na-section na-fotobio-empty">
              Nenhum tanque com leitura neste dia.
            </div>
            <template v-else>
              <!-- Todos os tanques: média de hora em hora de todos juntos -->
              <div :class="['na-section', 'na-temp-card', 'na-fotobio-card', 'na-clickable', { 'na-card-selected': isFotobioSelected('geral') }]"
                @click="selectSensorCard('fotobio', fotobioSourceId, 'geral')">
                <div class="na-temp-header">
                  <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                  <span>Todos os tanques</span>
                </div>
                <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(${temperatureRgb(fotobioMediaAtual)}, 0.12) 0%, rgba(255,255,255,0) 60%)` }">
                  <div class="na-temp-left">
                    <span class="na-temp-info-label">média atual</span>
                    <div class="na-soil-temp-value">{{ fotobioMediaAtual?.toFixed(2) ?? '--' }}<sup>°</sup>c</div>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">máxima</span>
                    <b class="na-temp-info-value">{{ fotobioResumoMax?.toFixed(2) ?? '--' }}°c</b>
                    <span class="na-temp-info-label">mínima</span>
                    <span class="na-temp-info-value">{{ fotobioResumoMin?.toFixed(2) ?? '--' }}°c</span>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">diferença</span>
                    <b class="na-temp-info-value">{{ fotobioAmplitudeAtual?.toFixed(2) ?? '--' }}°c</b>
                    <span class="na-temp-info-label">entre tanques</span>
                  </div>
                </div>
              </div>
              <div v-if="isFotobioSelected('geral')" class="na-chart-table-card na-fotobio-chart">
                <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
                <template v-else-if="fotobioGeralChartHours.length">
                  <div class="na-chart-legend">
                    <span v-for="s in fotobioGeralSeries" :key="s.field" class="na-chart-legend-item">
                      <span class="na-fotobio-dot" :style="{ background: s.color }"></span>{{ s.label }}
                    </span>
                  </div>
                  <NewAsideHistoryChart key="fotobio-geral" :hours="fotobioGeralChartHours" :metricField="'media'" :metricLabel="'Temperatura média (°C)'" :metricColor="'#495948'" :extraSeries="fotobioGeralSeries" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                  <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                  <NewAsideDataTable :hours="fotobioGeralChartHours" :columns="fotobioGeralTableColumns" />
                </template>
              </div>

              <!-- Um card por tanque; o gráfico abre logo abaixo do card clicado -->
              <template v-for="tank in fotobioTanks" :key="tank.field">
                <div :class="['na-section', 'na-temp-card', 'na-fotobio-card', 'na-clickable', { 'na-card-selected': isFotobioSelected(tank.field) }]"
                  @click="selectSensorCard('fotobio', fotobioSourceId, tank.field)">
                  <div class="na-temp-header">
                    <span class="na-fotobio-dot" :style="{ background: tank.color }"></span>
                    <span>{{ tank.label }}</span>
                  </div>
                  <div class="na-temp-body" :style="{ background: `linear-gradient(90deg, rgba(${temperatureRgb(tank.last)}, 0.12) 0%, rgba(255,255,255,0) 60%)` }">
                    <div class="na-temp-left">
                      <span class="na-temp-info-label">atual</span>
                      <div class="na-soil-temp-value">{{ tank.last?.toFixed(2) ?? '--' }}<sup>°</sup>c</div>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">máxima</span>
                      <b class="na-temp-info-value">{{ tank.max?.toFixed(2) ?? '--' }}°c</b>
                    </div>
                    <div class="na-temp-mid">
                      <span class="na-temp-info-label">mínima</span>
                      <b class="na-temp-info-value">{{ tank.min?.toFixed(2) ?? '--' }}°c</b>
                    </div>
                  </div>
                </div>
                <div v-if="isFotobioSelected(tank.field)" class="na-chart-table-card na-fotobio-chart">
                  <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
                  <template v-else-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                    <NewAsideHistoryChart :key="'fotobio-' + tank.field" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="tank.label + ' (°C)'" :metricColor="tank.color" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                    <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                    <NewAsideDataTable :hours="sensorStats.hours" :columns="sensorStatsTableColumns" />
                  </template>
                </div>
              </template>
            </template>
          </template>

          <!-- Medidor Ritter (vazão de gás). Cálculos no backend: RitterVazao.cs -->
          <template v-if="station.linkname === 'ritter'">
            <div class="na-section na-soil-group">
              <div class="na-ritter-top">
                <div class="na-soil-depth-label">Medidor <b>{{ ritterModelo }}</b></div>
                <div class="na-ritter-unit" @click.stop>
                  <button :class="{ active: ritterFlowUnit === 'h' }" @click="ritterFlowUnit = 'h'">L/h</button>
                  <button :class="{ active: ritterFlowUnit === 'min' }" @click="ritterFlowUnit = 'min'">L/min</button>
                </div>
              </div>

              <!-- Volume -->
              <div :class="['na-soil-card-half', 'na-fotobio-card', 'na-clickable', { 'na-card-selected': isRitterSelected('volume') }]"
                @click="selectSensorCard('ritter', ritterSourceId, 'volume')">
                <div class="na-temp-header">
                  <img src="..\mapa\src\components\mapa\stationIcon\NivelLiquidoBlack.svg" class="na-icon-20" alt="volume" />
                  <span>Volume do dia</span>
                </div>
                <div class="na-temp-body na-ritter-body" style="background: linear-gradient(90deg, rgba(46, 134, 222, 0.12) 0%, rgba(255,255,255,0) 100%)">
                  <div class="na-temp-left">
                    <span class="na-soil-temp-value">{{ formatLitros(currentDayResume.volumeDia) }} <small>L</small></span>
                  </div>
                  <div class="na-temp-mid">
                    <span class="na-temp-info-label">total acumulado</span>
                    <b class="na-temp-info-value">{{ formatLitros(currentDayResume.totalLitrosAcumulados) }} L</b>
                    <span class="na-temp-info-label">início da vazão</span>
                    <span class="na-temp-info-value">{{ currentDayResume.inicioVazao ? formatTime(currentDayResume.inicioVazao) : '--' }}</span>
                  </div>
                </div>
              </div>

              <!-- Vazão -->
              <div :class="['na-soil-card-half', 'na-fotobio-card', 'na-clickable', { 'na-card-selected': isRitterSelected('vazao') }]"
                @click="selectSensorCard('ritter', ritterSourceId, 'vazao')">
                <div class="na-temp-header">
                  <img src="..\mapa\src\components\mapa\stationIcon\Ritter.svg" class="na-icon-20" alt="vazão" />
                  <span>Vazão ({{ ritterUnitLabel }})</span>
                </div>
                <div class="na-temp-body na-ritter-flow" style="background: linear-gradient(90deg, rgba(231, 76, 60, 0.10) 0%, rgba(255,255,255,0) 100%)">
                  <div v-if="isUltimoDia" class="na-ritter-flow-col">
                    <span class="na-temp-info-label">agora</span>
                    <b class="na-soil-temp-value">{{ formatVazao(currentDayResume.vazaoInstantanea) }}</b>
                  </div>
                  <div v-if="isUltimoDia" class="na-ritter-flow-col">
                    <span class="na-temp-info-label">última hora</span>
                    <b class="na-soil-temp-value">{{ formatVazao(currentDayResume.vazaoUltimaHora) }}</b>
                  </div>
                  <div class="na-ritter-flow-col">
                    <span class="na-temp-info-label">média com fluxo</span>
                    <b class="na-soil-temp-value">{{ formatVazao(currentDayResume.vazaoMediaComFluxo) }}</b>
                  </div>
                </div>
              </div>

              <!-- Temperatura / Pressão -->
              <div class="na-soil-cards-row">
                <div :class="['na-soil-card-half', 'na-fotobio-card', 'na-clickable', { 'na-card-selected': isRitterSelected('temperature') }]"
                  @click="selectSensorCard('ritter', ritterSourceId, 'temperature')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-20" alt="temp" />
                    <span>Temperatura</span>
                  </div>
                  <div class="na-temp-body">
                    <span class="na-soil-temp-value">{{ hour.temperature?.toFixed(2) ?? '--' }}<sup>°</sup>c</span>
                  </div>
                </div>
                <div :class="['na-soil-card-half', 'na-fotobio-card', 'na-clickable', { 'na-card-selected': isRitterSelected('pressao') }]"
                  @click="selectSensorCard('ritter', ritterSourceId, 'pressao')">
                  <div class="na-temp-header">
                    <img src="..\mapa\src\components\mapa\stationIcon\BarometroBlack.svg" class="na-icon-20" alt="pressão" />
                    <span>Pressão</span>
                  </div>
                  <div class="na-temp-body">
                    <span class="na-soil-temp-value">{{ hour.pressao?.toFixed(1) ?? '--' }} <small>hPa</small></span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedCardKey && selectedCardKey.startsWith('ritter-')" class="na-chart-table-card">
              <div class="na-wind-tabs">
                <button :class="['na-wind-tab', { active: soilTab === 'vazao' }]" @click="soilTab = 'vazao'">Vazão</button>
                <button :class="['na-wind-tab', { active: soilTab === 'volume' }]" @click="soilTab = 'volume'">Volume</button>
                <button :class="['na-wind-tab', { active: soilTab === 'temperature' }]" @click="soilTab = 'temperature'">Temp.</button>
                <button :class="['na-wind-tab', { active: soilTab === 'pressao' }]" @click="soilTab = 'pressao'">Pressão</button>
              </div>
              <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
              <template v-else-if="sensorStats && sensorStats.hours && sensorStats.hours.length">
                <NewAsideHistoryChart v-if="soilTab === 'vazao'" :key="'ritter-vazao-' + ritterFlowUnit" :hours="ritterVazaoChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Vazão (' + ritterUnitLabel + ')'" :metricColor="'#E74C3C'" :zeroBased="true" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'volume'" key="ritter-volume" :hours="ritterVolumeChartHours" :metricField="'volume'" :metricLabel="'Volume do dia (L)'" :metricColor="'#2E86DE'" :zeroBased="true" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'temperature'" key="ritter-temp" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Temperatura (°C)'" :metricColor="'#F98601'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <NewAsideHistoryChart v-else-if="soilTab === 'pressao'" key="ritter-pressao" :hours="sensorStatsChartHours" :metricField="'avg'" :showMinMax="true" :metricLabel="'Pressão (hPa)'" :metricColor="'#727272'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="sensorStats.hours" :columns="ritterTableColumns" />
              </template>
            </div>
          </template>

          <!-- Vento -->
          <div :class="['na-section', 'na-wind-card', 'na-clickable', { 'na-card-selected': selectedCardKey === 'vento' }]"
            v-if="station.linkname === 'estacao'"
            @click="selectCard('vento', 'windSpeed')">
            <div class="na-wind-header">
              <img src="..\mapa\src\components\mapa\stationIcon\VentoBlack.svg" class="na-icon-20" alt="vento" />
              <span>Vento</span>
            </div>
            <div class="na-wind-body">
              <div class="na-wind-col">
                <span class="na-wind-label">velocidade</span>
                <span class="na-wind-value-lg">{{ hour.windSpeed?.toFixed(2) || '0' }} km/h</span>
              </div>
              <div class="na-wind-col na-wind-col-center">
                <div class="na-wind-dir-top">
                  <img
                    v-if="hour.windDirection"
                    :src="require(`../mapa/src/components/mapa/stationIcon/direcao/${hour.windDirection}.svg`)"
                    class="na-icon-24" alt="dir"
                  />
                  <span class="na-wind-label">direção</span>
                </div>
                <span class="na-wind-value-lg">{{ hour.windDirection || '--' }}</span>
              </div>
              <div class="na-wind-col">
                <span class="na-wind-label">rajada</span>
                <span class="na-wind-value-lg">{{ hour.gustSpeed?.toFixed(2) || '0' }} km/h</span>
              </div>
            </div>
          </div>
          <!-- Chart/Table after Vento if selected - with tabs -->
          <div v-if="selectedCardKey === 'vento'" class="na-chart-table-card">
            <div class="na-wind-tabs">
              <button :class="['na-wind-tab', { active: windTab === 'speed' }]" @click="switchWindTab('speed')">Vel. do Vento</button>
              <button :class="['na-wind-tab', { active: windTab === 'gust' }]" @click="switchWindTab('gust')">Rajada do Vento</button>
            </div>
            <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
            <template v-else-if="statsHours.length">
              <NewAsideHistoryChart :hours="windTabChartData" :metricField="'avg'" :showMinMax="true" :metricLabel="windTab === 'speed' ? 'Vento (km/h)' : 'Rajada (km/h)'" :metricColor="windTab === 'speed' ? '#727272' : '#10C537'" :collapsed="historyCollapsed" @toggle-collapse="historyCollapsed = !historyCollapsed" />
              <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
              <NewAsideDataTable :hours="statsHours" :columns="windTabTableColumns" />
            </template>
          </div>

          <!-- Metric cards with inline chart/table after selected -->
          <template v-if="station.linkname === 'estacao'">
            <template v-for="(row, rowIdx) in metricRows" :key="rowIdx">
              <!-- Row of 2 cards -->
              <div :class="row[0].isSpecialRow ? 'na-dt-dir-row' : 'na-metrics-grid'">
                <template v-for="card in row" :key="card.key">
                  <!-- Delta T card -->
                  <div v-if="card.type === 'deltaT'"
                    :class="['na-dt-card', { 'na-card-selected': selectedMetricKey === 'temperature' && selectedCardKey === 'deltaT' }]"
                    :style="selectedCardKey !== 'deltaT' ? { background: `radial-gradient(ellipse at 0% 0%, ${getDeltaTColor()}1F 0%, rgba(255,255,255,0.12) 100%), #fff` } : {}"
                    @click="selectCard('deltaT', 'temperature')">
                    <div class="na-dt-header">
                      <img src="../mapa/src/components/mapa/stationIcon/deltat/IDeltaT.svg" class="na-icon-20 na-dt-icon" alt="deltaT" />
                      <span class="na-dt-label">Delta T</span>
                    </div>
                    <div class="na-dt-bar"></div>
                    <div class="na-dt-values">
                      <span class="na-dt-number">{{ deltaT.value ?? 'N/D' }}</span>
                      <b class="na-dt-status">{{ deltaT.status || '' }}</b>
                    </div>
                  </div>
                  <!-- Regular metric card -->
                  <NewAsideMetricCard v-else
                    v-bind="card.metric"
                    :selected="selectedCardKey === card.metric.metricKey"
                    @select="selectCard(card.metric.metricKey, card.chartKey)"
                  />
                </template>
              </div>

              <!-- Delta T grid visualization -->
              <div v-if="selectedCardKey === 'deltaT' && isRowSelected(row)" class="na-chart-table-card">
                <div class="na-deltat-viz">
                  <div class="na-deltat-grid-header" @click="deltaTCollapsed = !deltaTCollapsed">
                    <span class="na-deltat-grid-title">Gráfico Delta-T</span>
                    <div class="na-deltat-grid-meta">
                      <span class="na-deltat-grid-date">{{ formatDate(hour.dateTimeLeitura || hour.dateTime) }}</span>
                      <span class="na-deltat-grid-time">{{ formatTime(hour.dateTimeLeitura || hour.dateTime) }}</span>
                      <font-awesome-icon
                        icon="fa fa-chevron-down"
                        :class="['na-arrow', { collapsed: deltaTCollapsed }]"
                      />
                    </div>
                  </div>
                  <div v-show="!deltaTCollapsed">
                    <div class="na-deltat-image-center">
                      <div class="na-deltat-image-wrapper">
                        <img src="../mapa/src/components/mapa/stationIcon/deltat/grid.png" alt="Delta-T Gráfico" />
                        <div v-if="deltaT.value !== null" class="na-deltat-point" :style="{ top: deltaT.pointY + 'px', left: deltaT.pointX + 'px' }">
                          <img v-if="deltaT.windDirection && deltaT.windDirection !== 'N/A'" :src="require(`../mapa/src/components/mapa/stationIcon/deltat/${deltaT.windDirection}.svg`)" alt="dir" />
                        </div>
                      </div>
                    </div>
                    <div class="na-deltat-info">
                      <span class="na-deltat-value">{{ deltaT.value }}</span>
                      <b class="na-deltat-status">{{ deltaT.status }}</b>
                      <span class="na-deltat-wind-dir">Vento ao {{ deltaT.windDirection }}</span>
                    </div>
                    <div class="na-deltat-icons-row">
                      <div class="na-deltat-icon-item">
                        <img src="..\mapa\src\components\mapa\stationIcon\VentoBlack.svg" class="na-icon-18" alt="Vento" />
                        <span>{{ deltaT.windSpeed }} km/h</span>
                      </div>
                      <div class="na-deltat-icon-item">
                        <img src="..\mapa\src\components\mapa\stationIcon\RajadaVentoBlack.svg" class="na-icon-18" alt="Rajada" />
                        <span>{{ deltaT.gustSpeed }} km/h</span>
                      </div>
                    </div>
                    <div class="na-deltat-icons-row">
                      <div class="na-deltat-icon-item">
                        <img src="..\mapa\src\components\mapa\stationIcon\TemperaturaBlack.svg" class="na-icon-18" alt="Temp" />
                        <span>{{ deltaT.temperature }} °C</span>
                      </div>
                      <div class="na-deltat-icon-item">
                        <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-18" alt="Umid" />
                        <span>{{ deltaT.humidity }}%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                <NewAsideDataTable :hours="currentDayHours" :columns="deltaTColumns" />
              </div>

              <!-- Ponto de Orvalho info -->
              <div v-else-if="selectedCardKey === 'pontoOrvalho' && isRowSelected(row)" class="na-chart-table-card">
                <div class="na-info-card">
                  <div class="na-info-title">
                    <img src="..\mapa\src\components\mapa\stationIcon\PontoOrvalho.svg" class="na-icon-20" alt="orvalho" />
                    <b>Ponto de Orvalho</b>
                  </div>
                  <p>O <b>ponto de orvalho</b> é a temperatura na qual o vapor de água presente no ar começa a se condensar, formando orvalho, neblina ou nuvens.</p>
                  <p>Quanto mais próximo o ponto de orvalho estiver da temperatura atual, maior a umidade relativa do ar. Quando ambos são iguais, a umidade atinge 100%.</p>
                  <p>Na agricultura, é um indicador importante para prever formação de orvalho nas folhas (favorecendo doenças fúngicas), risco de geada e condições ideais para aplicação de defensivos.</p>
                  <div class="na-info-current">
                    <span>Valor atual:</span>
                    <b>{{ calcPontoOrvalho() }}°c</b>
                  </div>
                </div>
              </div>

              <!-- Evapotranspiração info -->
              <div v-else-if="selectedCardKey === 'evapotranspiracao' && isRowSelected(row)" class="na-chart-table-card">
                <div class="na-info-card">
                  <div class="na-info-title">
                    <img src="..\mapa\src\components\mapa\stationIcon\UmidadeBlack.svg" class="na-icon-20" alt="evapo" />
                    <b>Evapotranspiração</b>
                  </div>
                  <p>A <b>evapotranspiração (ETo)</b> representa a quantidade de água que é transferida do solo e das plantas para a atmosfera por evaporação e transpiração.</p>
                  <p>É um parâmetro fundamental para o manejo de irrigação, permitindo calcular a necessidade hídrica das culturas e evitar tanto o excesso quanto a falta de água.</p>
                  <p>O valor é estimado pelo método de Hargreaves, utilizando a temperatura máxima e mínima do dia.</p>
                  <div class="na-info-current">
                    <span>Valor estimado:</span>
                    <b>{{ calcEvapotranspiracao() }}mm</b>
                  </div>
                </div>
              </div>

              <!-- Regular chart + table for other metrics -->
              <div v-else-if="isRowSelected(row)" class="na-chart-table-card">
                <div v-if="loadingStats" class="na-loading-center"><Load color="#006035" /></div>
                <template v-else-if="statsHours.length">
                  <NewAsideHistoryChart
                    :hours="statsChartData"
                    :metricField="'avg'"
                    :showMinMax="!isRainfallMetric"
                    :metricLabel="selectedChartMetric.label"
                    :metricColor="selectedChartMetric.color"
                    :chartType="selectedChartMetric.chartType || 'line'"
                    :collapsed="historyCollapsed"
                    @toggle-collapse="historyCollapsed = !historyCollapsed"
                  />
                  <div class="na-chart-table-logo"><img src="..\mapa\src\components\mapa\stationIcon\Logobox.svg" alt="OnAgro" /></div>
                  <NewAsideDataTable
                    :hours="statsHours"
                    :columns="statsTableColumns"
                  />
                </template>
              </div>
            </template>
          </template>

        </div>
        </div><!-- /na-days-container -->

        <!-- Comparar: só quando o dispositivo está num grupo com outros que o usuário vê.
             Pública / liberado só no mapa não compara, igual a relatório e alerta. -->
        <div v-if="expandedDayIndex !== null && gruposComparacao.length && !isPublicOnly && !isViewOnly" class="na-report-container">
          <a v-for="g in gruposComparacao" :key="g.id" :href="comparacaoLink(g)" class="na-btn-compare">
            comparar<template v-if="gruposComparacao.length > 1"> · {{ g.nome }}</template>
          </a>
        </div>

        <!-- Gerar relatório button (outside bordered container) -->
        <div v-if="expandedDayIndex !== null && !isPublicOnly && !isViewOnly" class="na-report-container">
          <a :href="reportLink" class="na-btn-report">
            gerar relatório
          </a>
          <a :href="alertLink" class="na-btn-alert">
            cadastrar alerta
          </a>
        </div>
        </template>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="load" class="text-center m-auto p-5">
      <Load color="#006035"></Load>
    </div>
  </div>
</template>

<script>
import Load from "../Load.vue";
import MaskIcon from "../MaskIcon.vue";
import NewAsideDayItem from "./NewAsideDayItem.vue";
import NewAsideMetricCard from "./NewAsideMetricCard.vue";
import NewAsideHistoryChart from "./NewAsideHistoryChart.vue";
import NewAsideDataTable from "./NewAsideDataTable.vue";
import { moonPhaseInfo } from "./moonPhase";
import {
  SONDA_LINKNAMES,
  caixaFormato,
  caixaFormatoDesenho,
  caixaSemGeometria,
  caixaCapacidade,
  caixaVolume,
  CAIXA_REDONDA,
} from "../../mixin/sondas";
import WaterTank from "./WaterTank.vue";

// Ícone (SVG) por tipo de sensor (linkname). Tipos sem sensor operando ainda
// (energia, chuva, fotobio, etc.) ficam sem ícone (null) — só nome.
const SENSOR_ICONS = {
  estacao: require("./src/components/mapa/stationIcon/Estacao.svg"),
  solo: require("./src/components/mapa/stationIcon/Sensor Solo.svg"),
  folhar: require("./src/components/mapa/stationIcon/Sensor Folhar.svg"),
  ambiente: require("./src/components/mapa/stationIcon/Ambiente.svg"),
  lut: require("./src/components/mapa/stationIcon/lut-and-fotobio.svg"),
  fotobio: require("./src/components/mapa/stationIcon/lut-and-fotobio.svg"),
  piranometro: require("./src/components/mapa/stationIcon/Piranometro.svg"),
  ritter: require("./src/components/mapa/stationIcon/Ritter.svg"),
  "sonda-hidrostatica": require("./src/components/mapa/stationIcon/Sonda-hidro-and-nivel.svg"),
  "sonda-nivel": require("./src/components/mapa/stationIcon/Sonda-hidro-and-nivel.svg"),
  "sonda-laser": require("./src/components/mapa/stationIcon/Sonda-Laser.svg"),
  // Caixa d'água reusa a arte de hidro/nível até ter ícone dedicado.
  "sonda-caixa": require("./src/components/mapa/stationIcon/Sonda-hidro-and-nivel.svg"),
};

// Fotobio: o payload traz até 6 tanques (temp_1..temp_6). Tanque sem sonda chega
// como 0 em todas as leituras e não é mostrado.
const FOTOBIO_TANQUES = [
  { field: "temp1", label: "Tanque 1", short: "T1", color: "#F98601" },
  { field: "temp2", label: "Tanque 2", short: "T2", color: "#E53935" },
  { field: "temp3", label: "Tanque 3", short: "T3", color: "#3E97FF" },
  { field: "temp4", label: "Tanque 4", short: "T4", color: "#10C537" },
  { field: "temp5", label: "Tanque 5", short: "T5", color: "#9B59B6" },
  { field: "temp6", label: "Tanque 6", short: "T6", color: "#1ABC9C" },
];

const formatHora = (row) => { const h = row.hour; return (h < 10 ? "0" : "") + h + ":00"; };

const CHART_METRICS = {
  temperature: { field: "temperature", label: "Temperatura (°C)", color: "#F49C18", chartType: "line" },
  humidity: { field: "humidity", label: "Umidade (%)", color: "#3E97FF", chartType: "line" },
  windSpeed: { field: "windSpeed", label: "Vento (km/h)", color: "#727272", chartType: "line" },
  gustSpeed: { field: "gustSpeed", label: "Rajada (km/h)", color: "#10C537", chartType: "line" },
  rainfall: { field: "rainfall", label: "Chuva (mm)", color: "#3B82F6", chartType: "bar" },
  pressureInHpa: { field: "pressureInHpa", label: "Pressão (hPa)", color: "#FF3E3E", chartType: "line" },
  uvi: { field: "uvi", label: "UVI", color: "#E8D746", chartType: "line" },
  solarRadiation: { field: "solarRadiation", label: "Radiação Solar (W/m²)", color: "#EB681D", chartType: "line" },
  light: { field: "light", label: "Luminosidade (lux)", color: "#839682", chartType: "line" },
  depthCalc: { field: "depthCalc", label: "Profundidade (m)", color: "#495948", chartType: "line" },
};

export default {
  name: "NewAsideDevice",
  components: {
    Load,
    MaskIcon,
    NewAsideDayItem,
    NewAsideMetricCard,
    NewAsideHistoryChart,
    NewAsideDataTable,
    WaterTank,
  },

  data() {
    return {
      station: {
        nome: "Estação",
        linkname: "estacao",
        sourceId: "default",
      },
      sensorList: [],
      selectedSensorIndex: 0,
      sensorDropdownOpen: false,
      info: null,
      // Contadores de requisição: só a resposta da chamada mais recente entra na tela.
      dataRequestId: 0,
      statsRequestId: 0,
      isPublicOnly: false,
      load: true,
      data: null,
      expandedDayIndex: null,
      qrCodeId: null,
      premium: null,
      bateriaOnConnect: null,
      propriedadeAgricolaId: null,
      propriedadeNome: null,
      nomeDispositivo: null,
      // Dispositivo compartilhado comigo (não é meu nem público). Vem do pin
      // (campo "compartilhado" do GetStationPin) via Dashboard.
      isSharedDevice: false,
      // Liberado pelo admin só para visualização no mapa (campo "somenteVisualizacao"
      // do GetStationPin): vê os dados, mas sem relatório nem alerta.
      isViewOnly: false,
      showBatteryTooltip: false,
      selectedMetricKey: "windSpeed",
      selectedCardKey: null,
      historyCollapsed: false,
      deltaTCollapsed: false,
      windTab: "speed",
      tempTab: "temperature",
      soilTab: "temperature",
      // Unidade de vazão do Ritter (só exibição: L/min = L/h ÷ 60).
      ritterFlowUnit: "min",
      // Grupos de comparação do dispositivo com 2+ dispositivos visíveis ao usuário.
      gruposComparacao: [],
      hourlyStats: null,
      sensorStats: null,
      loadingStats: false,
      next: null,
      deltaT: {
        value: null,
        status: null,
        windDirection: "N/A",
        temperature: null,
        windSpeed: null,
        humidity: null,
        gustSpeed: null,
        pointX: 32,
        pointY: 270,
      },
    };
  },

  computed: {
    // Leitura atual = última hora do dia aberto. Computed (e não cópia em data) para
    // nunca ficar de uma resposta diferente da que está em `info`.
    hour() {
      const hours = this.currentDayHours;
      return hours.length ? hours[hours.length - 1] : null;
    },
    // Exposto ao template para não repetir a lista de linknames de sonda no HTML.
    sondaLinknames() {
      return SONDA_LINKNAMES;
    },
    isComingSoonSensor() {
      return ['chuva', 'energia', 'energia-smtp', 'piranometro'].includes(this.station.linkname);
    },
    // Link para a página de relatório já com os campos pré-preenchidos com o
    // módulo (qrCode), sensor, sourceId e a data do dia atualmente expandido.
    reportLink() {
      const params = new URLSearchParams();
      if (this.qrCodeId != null) params.append('qrCodeId', this.qrCodeId);
      // Compartilhado comigo: a propriedade real é do dono e não está na minha
      // lista, então sinalizo "shared" para o form usar "Compartilhados Comigo".
      if (this.isSharedDevice) {
        params.append('shared', '1');
      } else {
        if (this.propriedadeAgricolaId != null) params.append('propriedadeId', this.propriedadeAgricolaId);
        if (this.propriedadeNome) params.append('propriedadeNome', this.propriedadeNome);
      }
      if (this.nomeDispositivo) params.append('nomeDispositivo', this.nomeDispositivo);
      if (this.station.linkname) params.append('sensor', this.station.linkname);
      if (this.station.sourceId != null) params.append('sourceId', this.station.sourceId);
      const sensor = this.sensorList[this.selectedSensorIndex];
      if (sensor && sensor.nome) params.append('sensorNome', sensor.nome);
      const day = this.info && this.expandedDayIndex !== null
        ? this.info.days[this.expandedDayIndex]
        : null;
      if (day && day.date) {
        params.append('date', new Date(day.date).toISOString().split('T')[0]);
      }
      const query = params.toString();
      return query ? `/report?${query}` : '/report';
    },
    // Link para a tela de alertas já com o formulário de novo alerta aberto e
    // pré-preenchido com a propriedade, o módulo (qrCode) e o sensor do aside.
    // A visibilidade segue a mesma regra do relatório (!isPublicOnly), que
    // equivale ao item "Alertas" do menu (level 0 = qualquer usuário logado).
    alertLink() {
      const params = new URLSearchParams();
      if (this.qrCodeId != null) params.append('qrCodeId', this.qrCodeId);
      // Compartilhado comigo: a propriedade real é do dono e não está na minha
      // lista, então sinalizo "shared" para o form usar "Compartilhados Comigo".
      if (this.isSharedDevice) {
        params.append('shared', '1');
      } else {
        if (this.propriedadeAgricolaId != null) params.append('propriedadeId', this.propriedadeAgricolaId);
        if (this.propriedadeNome) params.append('propriedadeNome', this.propriedadeNome);
      }
      if (this.nomeDispositivo) params.append('nomeDispositivo', this.nomeDispositivo);
      if (this.station.linkname) params.append('sensor', this.station.linkname);
      if (this.station.sourceId != null) params.append('sourceId', this.station.sourceId);
      const query = params.toString();
      return query ? `/alert?${query}` : '/alert';
    },
    displayDays() {
      if (!this.info || !this.info.days) return [];
      const all = this.info.days.map((day, originalIndex) => ({ day, originalIndex }));
      // LUT: exibe apenas os dias que possuem leituras
      if (this.station.linkname === 'lut') {
        return all.filter((d) => (d.day.hours || []).length > 0);
      }
      return all;
    },
    currentDayHours() {
      if (!this.info || this.expandedDayIndex === null) return [];
      return this.info.days[this.expandedDayIndex]?.hours || [];
    },
    currentDayResume() {
      if (!this.info || this.expandedDayIndex === null) return {};
      return this.info.days[this.expandedDayIndex]?.resume || {};
    },
    currentBattery() {
      if (!this.hour || this.hour.battery == null) return null;
      return Number(this.hour.battery);
    },
    onConnectBatteryPercentage() {
      if (!this.bateriaOnConnect) return "0%";
      const level = parseFloat(this.bateriaOnConnect);
      let minV, maxV;
      if (level < 6.0) { minV = 2.8; maxV = 4.2; }
      else { minV = 8.2; maxV = 12.6; }
      const pct = Math.max(0, Math.min(100, ((level - minV) / (maxV - minV)) * 100));
      return Math.round(pct) + "%";
    },
    onConnectBatteryColor() {
      if (!this.bateriaOnConnect) return "#999";
      const level = parseFloat(this.bateriaOnConnect);
      let minV, maxV;
      if (level < 6.0) { minV = 2.8; maxV = 4.2; }
      else { minV = 8.2; maxV = 12.6; }
      const pct = Math.max(0, Math.min(100, ((level - minV) / (maxV - minV)) * 100));
      if (pct >= 60) return "#4CAF50";
      if (pct >= 30) return "#FF9800";
      return "#F44336";
    },
    onConnectBatteryRound() {
      if (!this.bateriaOnConnect) return 0;
      const level = parseFloat(this.bateriaOnConnect);
      let minV, maxV;
      if (level < 6.0) { minV = 2.8; maxV = 4.2; }
      else { minV = 8.2; maxV = 12.6; }
      return Math.round(Math.max(0, Math.min(100, ((level - minV) / (maxV - minV)) * 100)));
    },
    onConnectBatteryFillWidth() {
      return Math.max(5, (this.onConnectBatteryRound * 21) / 100) + "px";
    },
    currentDayAstronomia() {
      if (!this.info || this.expandedDayIndex === null) return null;
      return this.info.days[this.expandedDayIndex]?.astronomia || null;
    },
    sondaSensors() {
      if (!SONDA_LINKNAMES.includes(this.station.linkname) || !this.currentDayHours.length) return [];
      const grouped = {};
      this.currentDayHours.forEach(h => {
        const key = h.sourceId || 'default';
        if (!grouped[key]) {
          grouped[key] = { sourceId: key, hours: [] };
        }
        grouped[key].hours.push(h);
      });
      return Object.values(grouped);
    },
    soilSensors() {
      if (this.station.linkname !== 'solo' || !this.currentDayHours.length) return [];
      const grouped = {};
      this.currentDayHours.forEach(h => {
        const key = h.sourceId || 'default';
        if (!grouped[key]) {
          grouped[key] = { sourceId: key, depth: h.depth, hours: [] };
        }
        grouped[key].hours.push(h);
      });
      return Object.values(grouped).sort((a, b) => (a.depth || 0) - (b.depth || 0));
    },
    selectedAmbientHasHumidity() {
      if (!this.selectedCardKey || !this.selectedCardKey.startsWith('ambiente-')) return false;
      const sourceId = this.selectedCardKey.replace('ambiente-', '');
      const sensor = this.ambientSensors.find(s => s.sourceId === sourceId);
      return sensor ? this.sensorHasHumidity(sensor) : false;
    },
    selectedSoilSensor() {
      if (!this.selectedCardKey || !this.selectedCardKey.startsWith('solo-')) return null;
      const sourceId = this.selectedCardKey.replace('solo-', '');
      return this.soilSensors.find(s => s.sourceId === sourceId) || null;
    },
    soilTableColumns() {
      const cols = [
        { key: "hora", label: "Hora", format: "time", width: "30%" },
      ];
      if (this.soilTab === 'all' || this.soilTab === 'temperature') {
        cols.push({ key: "temp", label: "Temp (°C)", formatter: (row) => row.temperature != null ? row.temperature.toFixed(1) : "--" });
      }
      if (this.soilTab === 'all' || this.soilTab === 'humidity') {
        cols.push({ key: "umid", label: "Umid (%)", formatter: (row) => row.humidity != null ? row.humidity.toFixed(1) : "--" });
      }
      return cols;
    },
    sensorStatsTableColumns() {
      const field = this.sensorStatsField;
      return [
        { key: "hora", label: "Hora", formatter: (row) => { const h = row.hour; return (h < 10 ? "0" : "") + h + ":00"; } },
        { key: "min", label: "Mínima", formatter: (row) => row[field]?.min?.toFixed(2) ?? "--" },
        { key: "max", label: "Máxima", formatter: (row) => row[field]?.max?.toFixed(2) ?? "--" },
        { key: "avg", label: "Média", formatter: (row) => row[field]?.avg?.toFixed(2) ?? "--" },
      ];
    },
    sensorStatsChartHours() {
      if (!this.sensorStats || !this.sensorStats.hours) return [];
      const field = this.sensorStatsField;
      return this.sensorStats.hours.map(h => ({
        dateTime: h.dateTime,
        avg: h[field]?.avg ?? 0,
        min: h[field]?.min ?? 0,
        max: h[field]?.max ?? 0,
      }));
    },
    sensorStatsField() {
      if (SONDA_LINKNAMES.includes(this.station.linkname)) return 'depthCalc';
      if (this.station.linkname === 'lut') {
        if (this.soilTab === 'humidity') return 'humidity';
        if (this.soilTab === 'lux') return 'lux';
        return 'temperature';
      }
      // Fotobio: a aba é o próprio campo do tanque (temp1..temp6).
      if (this.station.linkname === 'fotobio') return this.soilTab;
      if (this.station.linkname === 'ritter') {
        if (this.soilTab === 'volume') return 'volumeHoje';
        return this.soilTab;
      }
      return this.soilTab === 'humidity' ? 'humidity' : 'temperature';
    },
    isUltimoDia() {
      return !!this.info && this.expandedDayIndex === this.info.days.length - 1;
    },
    fotobioSourceId() {
      return (this.hour && this.hour.sourceId) || this.station.sourceId || 'default';
    },
    fotobioTanks() {
      if (this.station.linkname !== 'fotobio') return [];
      const hours = this.currentDayHours;
      const last = hours[hours.length - 1] || {};
      // Máx/mín e quais tanques estão ativos vêm do resumo do dia, que usa todas as
      // leituras (as horas trazem só a última leitura de cada hora).
      const resumo = this.currentDayResume.tanques || [];
      return FOTOBIO_TANQUES.map((t) => {
        const r = resumo.find((x) => x.field === t.field);
        if (!r) return null;
        return { ...t, last: last[t.field] ?? null, max: r.max, min: r.min };
      }).filter(Boolean);
    },
    fotobioUltimasLeituras() {
      return this.fotobioTanks.map((t) => t.last).filter((v) => v != null && v !== 0);
    },
    fotobioMediaAtual() {
      const v = this.fotobioUltimasLeituras;
      return v.length ? v.reduce((a, b) => a + b, 0) / v.length : null;
    },
    fotobioAmplitudeAtual() {
      const v = this.fotobioUltimasLeituras;
      return v.length > 1 ? Math.max(...v) - Math.min(...v) : null;
    },
    // Mesmo valor do botão do dia (resumo sobre todas as leituras).
    fotobioResumoMax() {
      return this.fotobioTanks.length ? this.currentDayResume.temperatureMax : null;
    },
    fotobioResumoMin() {
      return this.fotobioTanks.length ? this.currentDayResume.temperatureMin : null;
    },
    fotobioGeralSeries() {
      return [
        ...this.fotobioTanks.map((t) => ({ field: t.field, label: t.label, color: t.color })),
        { field: 'media', label: 'Média', color: '#495948' },
      ];
    },
    // Uma linha por hora com a média de cada tanque e a média geral entre eles.
    fotobioGeralChartHours() {
      if (!this.sensorStats || !this.sensorStats.hours) return [];
      return this.sensorStats.hours.map((h) => {
        const row = { hour: h.hour, dateTime: h.dateTime };
        const medias = [];
        this.fotobioTanks.forEach((t) => {
          const avg = h[t.field]?.avg ?? null;
          row[t.field] = avg;
          if (avg != null && avg !== 0) medias.push(avg);
        });
        row.media = medias.length ? medias.reduce((a, b) => a + b, 0) / medias.length : null;
        return row;
      });
    },
    fotobioGeralTableColumns() {
      const fmt = (field) => (row) => row[field] != null ? row[field].toFixed(2) : "--";
      return [
        { key: "hora", label: "Hora", formatter: formatHora },
        ...this.fotobioTanks.map((t) => ({ key: t.field, label: t.short, formatter: fmt(t.field) })),
        { key: "media", label: "Média", formatter: fmt('media') },
      ];
    },
    ritterSourceId() {
      return (this.hour && this.hour.sourceId) || this.station.sourceId || 'default';
    },
    ritterModelo() {
      return (this.hour && this.hour.modelo) || 'Ritter';
    },
    ritterUnitLabel() {
      return this.ritterFlowUnit === 'min' ? 'L/min' : 'L/h';
    },
    ritterFlowFactor() {
      return this.ritterFlowUnit === 'min' ? 1 / 60 : 1;
    },
    ritterVazaoChartHours() {
      if (!this.sensorStats || !this.sensorStats.hours) return [];
      const f = this.ritterFlowFactor;
      return this.sensorStats.hours.map((h) => ({
        dateTime: h.dateTime,
        avg: h.vazao ? h.vazao.avg * f : null,
        min: h.vazao ? h.vazao.min * f : null,
        max: h.vazao ? h.vazao.max * f : null,
      }));
    },
    // Volume do dia é acumulado: o valor da hora é o máximo lido nela.
    ritterVolumeChartHours() {
      if (!this.sensorStats || !this.sensorStats.hours) return [];
      return this.sensorStats.hours.map((h) => ({ dateTime: h.dateTime, volume: h.volumeHoje?.max ?? null }));
    },
    ritterTableColumns() {
      if (this.soilTab === 'vazao') {
        const f = this.ritterFlowFactor;
        const unit = this.ritterUnitLabel;
        const fmt = (key) => (row) => row.vazao ? this.formatVazaoNumero(row.vazao[key] * f) : "--";
        return [
          { key: "hora", label: "Hora", formatter: formatHora },
          { key: "min", label: `Mín (${unit})`, formatter: fmt('min') },
          { key: "avg", label: `Méd (${unit})`, formatter: fmt('avg') },
          { key: "max", label: `Máx (${unit})`, formatter: fmt('max') },
        ];
      }
      if (this.soilTab === 'volume') {
        return [
          { key: "hora", label: "Hora", formatter: formatHora },
          { key: "volumeHora", label: "Na hora (L)", formatter: (row) => this.formatLitros(row.volumeHora) },
          { key: "volumeHoje", label: "No dia (L)", formatter: (row) => this.formatLitros(row.volumeHoje?.max) },
        ];
      }
      return this.sensorStatsTableColumns;
    },
    leafSensors() {
      if (this.station.linkname !== 'folhar' || !this.currentDayHours.length) return [];
      const grouped = {};
      this.currentDayHours.forEach(h => {
        const key = h.sourceId || 'default';
        if (!grouped[key]) grouped[key] = { sourceId: key, hours: [] };
        grouped[key].hours.push(h);
      });
      return Object.values(grouped);
    },
    ambientSensors() {
      if (this.station.linkname !== 'ambiente' || !this.currentDayHours.length) return [];
      const grouped = {};
      this.currentDayHours.forEach(h => {
        const key = h.sourceId || 'default';
        if (!grouped[key]) grouped[key] = { sourceId: key, hours: [] };
        grouped[key].hours.push(h);
      });
      return Object.values(grouped);
    },
    lutSensors() {
      if (this.station.linkname !== 'lut' || !this.currentDayHours.length) return [];
      const grouped = {};
      this.currentDayHours.forEach(h => {
        const key = h.sourceId || 'default';
        if (!grouped[key]) grouped[key] = { sourceId: key, hours: [] };
        grouped[key].hours.push(h);
      });
      return Object.values(grouped);
    },
    luaFaseInfo() {
      return moonPhaseInfo(this.currentDayAstronomia?.luaFase, this.currentDayAstronomia?.luaLuminosidade);
    },
    luaFaseLabel() {
      return this.luaFaseInfo?.label || "";
    },
    luaFaseIcon() {
      return this.luaFaseInfo?.icon || null;
    },
    expandedContentRadius() {
      if (!this.info || this.expandedDayIndex === null) return {};
      const isFirst = this.expandedDayIndex === 0;
      const isLast = this.expandedDayIndex === this.info.days.length - 1;
      const tl = isFirst ? '0' : '10px';
      const tr = isLast ? '0' : '10px';
      return { borderRadius: `${tl} ${tr} 10px 10px` };
    },
    selectedChartMetric() {
      return CHART_METRICS[this.selectedMetricKey] || CHART_METRICS.windSpeed;
    },
    metricsList() {
      if (!this.hour || this.station.linkname !== "estacao") return [];
      const h = this.hour;
      return [
        { metricKey: "rainfall", label: "Chuva\nacumulada", value: this.currentDayResume.rainfallTotal?.toFixed(2) ?? "0", unit: "mm", iconSrc: require("../mapa/src/components/mapa/stationIcon/ChuvaBlack.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(0, 132, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%)" },
        { metricKey: "deltaT", label: "Delta T", value: this.deltaT.value ?? "N/D", unit: this.deltaT.status || "", colorBar: true },
        { metricKey: "pressureInHpa", label: "Pressão\nbarométrica", value: h.pressureInHpa, unit: "mbar", iconSrc: require("../mapa/src/components/mapa/stationIcon/BarometroBlack.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(1, 104, 147, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%)" },
        { metricKey: "solarRadiation", label: "Radiação\nsolar", value: h.solarRadiation != null ? h.solarRadiation.toFixed(2) : "N/D", unit: "W/m²", iconSrc: require("../mapa/src/components/mapa/stationIcon/Piranometro.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(235, 104, 29, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%)" },
        { metricKey: "light", label: "Luminosidade", value: h.light != null ? h.light.toFixed(2) : "N/D", unit: "lux", iconSrc: require("../mapa/src/components/mapa/stationIcon/Luminosidade.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(255, 236, 62, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%)" },
        { metricKey: "uvi", label: "UVI", value: h.uvi, unit: "", iconSrc: require("../mapa/src/components/mapa/stationIcon/UVI.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(235, 104, 29, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%)" },
        // { metricKey: "bulboUmido", label: "Bulbo úmido", value: this.calcBulboUmido(), unit: "", iconSrc: require("../mapa/src/components/mapa/stationIcon/UmidadeBlack.svg") },
        { metricKey: "evapotranspiracao", label: "Evapotranspiração", value: this.calcEvapotranspiracao(), unit: "mm", inlineUnit: true, iconSrc: require("../mapa/src/components/mapa/stationIcon/UmidadeBlack.svg") },
        // { metricKey: "geada", label: "Geada", value: this.calcGeada(), unit: "°c", inlineUnit: true, iconSrc: require("../mapa/src/components/mapa/stationIcon/TemperaturaBlack.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(0, 238, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%)" },
        { metricKey: "pontoOrvalho", label: "Ponto de orvalho", value: this.calcPontoOrvalho(), unit: "", iconSrc: require("../mapa/src/components/mapa/stationIcon/PontoOrvalho.svg"), gradient: "radial-gradient(ellipse at 0% 0%, rgba(0, 255, 68, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%)" },
      ];
    },
    statsHours() {
      if (!this.hourlyStats || !this.hourlyStats.hours) return [];
      return this.hourlyStats.hours;
    },
    statsChartData() {
      // Transform hourly stats into format compatible with HistoryChart
      if (!this.hourlyStats || !this.hourlyStats.hours) return [];
      const field = this.statsMetricField;
      // Rainfall is a scalar value, not MetricStats
      if (this.isRainfallMetric) {
        return this.hourlyStats.hours.map(h => ({
          dateTime: h.dateTime,
          avg: h.rainfall ?? 0,
          min: h.rainfall ?? 0,
          max: h.rainfall ?? 0,
        }));
      }
      return this.hourlyStats.hours.map(h => ({
        dateTime: h.dateTime,
        avg: h[field]?.avg ?? 0,
        min: h[field]?.min ?? 0,
        max: h[field]?.max ?? 0,
      }));
    },
    isRainfallMetric() {
      return this.selectedMetricKey === "rainfall";
    },
    statsMetricField() {
      // Map selectedMetricKey to the stats field name
      const map = {
        temperature: "temperature",
        humidity: "humidity",
        pressureInHpa: "pressure",
        windSpeed: "windSpeed",
        gustSpeed: "gustSpeed",
        solarRadiation: "solarRadiation",
        uvi: "uvi",
        light: "light",
        rainfall: "rainfall",
      };
      return map[this.selectedMetricKey] || "temperature";
    },
    statsTableColumns() {
      const field = this.statsMetricField;
      const horaCol = { key: "hora", label: "Hora", formatter: (row) => { const h = row.hour; return (h < 10 ? "0" : "") + h + ":00"; } };
      // Rainfall is a scalar value - single column
      if (this.isRainfallMetric) {
        return [
          horaCol,
          { key: "rainfall", label: "Precipitação (mm)", formatter: (row) => row.rainfall != null ? row.rainfall.toFixed(2) : "--" },
        ];
      }
      return [
        horaCol,
        { key: "min", label: "Mínima", formatter: (row) => row[field]?.min?.toFixed(2) ?? "--" },
        { key: "max", label: "Máxima", formatter: (row) => row[field]?.max?.toFixed(2) ?? "--" },
        { key: "avg", label: "Média", formatter: (row) => row[field]?.avg?.toFixed(2) ?? "--" },
      ];
    },
    tempTabChartData() {
      if (!this.hourlyStats || !this.hourlyStats.hours) return [];
      const field = this.tempTab === "temperature" ? "temperature" : "humidity";
      return this.hourlyStats.hours.map(h => ({
        dateTime: h.dateTime,
        avg: h[field]?.avg ?? 0,
        min: h[field]?.min ?? 0,
        max: h[field]?.max ?? 0,
      }));
    },
    tempTabTableColumns() {
      const field = this.tempTab === "temperature" ? "temperature" : "humidity";
      return [
        { key: "hora", label: "Hora", formatter: (row) => { const h = row.hour; return (h < 10 ? "0" : "") + h + ":00"; } },
        { key: "min", label: "Mínima", formatter: (row) => row[field]?.min?.toFixed(2) ?? "--" },
        { key: "max", label: "Máxima", formatter: (row) => row[field]?.max?.toFixed(2) ?? "--" },
        { key: "avg", label: "Média", formatter: (row) => row[field]?.avg?.toFixed(2) ?? "--" },
      ];
    },
    windTabChartData() {
      if (!this.hourlyStats || !this.hourlyStats.hours) return [];
      const field = this.windTab === "speed" ? "windSpeed" : "gustSpeed";
      return this.hourlyStats.hours.map(h => ({
        dateTime: h.dateTime,
        avg: h[field]?.avg ?? 0,
        min: h[field]?.min ?? 0,
        max: h[field]?.max ?? 0,
      }));
    },
    windTabTableColumns() {
      const field = this.windTab === "speed" ? "windSpeed" : "gustSpeed";
      return [
        { key: "hora", label: "Hora", formatter: (row) => { const h = row.hour; return (h < 10 ? "0" : "") + h + ":00"; } },
        { key: "min", label: "Mínima", formatter: (row) => row[field]?.min?.toFixed(2) ?? "--" },
        { key: "max", label: "Máxima", formatter: (row) => row[field]?.max?.toFixed(2) ?? "--" },
        { key: "avg", label: "Média", formatter: (row) => row[field]?.avg?.toFixed(2) ?? "--" },
        { key: "dir", label: "Direção", imageSrc: (row) => row.windDirection ? require(`../mapa/src/components/mapa/stationIcon/direcao/${row.windDirection}.svg`) : null },
      ];
    },
    deltaTColumns() {
      return [
        { key: "hora", label: "Hora", format: "time", width: "20%" },
        { key: "temperature", label: "Temp (°C)", formatter: (row) => row.temperature != null ? row.temperature.toFixed(2) : "--" },
        { key: "humidity", label: "Umid (%)", formatter: (row) => row.humidity ?? "--" },
        { key: "windSpeed", label: "Vento (km/h)", formatter: (row) => row.windSpeed != null ? row.windSpeed.toFixed(2) : "--" },
        { key: "windDirection", label: "Direção", imageSrc: (row) => row.windDirection ? require(`../mapa/src/components/mapa/stationIcon/direcao/${row.windDirection}.svg`) : null },
      ];
    },
    remainingMetrics() {
      return this.metricsList.filter(m => m.metricKey !== "deltaT" && m.metricKey !== "rainfall");
    },
    metricRows() {
      // Build rows of 2 cards, with rainfall + deltaT as first row
      const chartMap = {
        deltaT: "temperature",
        uvi: "uvi", solarRadiation: "solarRadiation", light: "light", pressureInHpa: "pressureInHpa",
        rainfall: "rainfall", bulboUmido: "temperature",
        evapotranspiracao: "temperature", geada: "temperature", pontoOrvalho: "temperature",
      };
      const rows = [];
      // First row: Chuva acumulada + Delta T
      const rainfallMetric = this.metricsList.find(m => m.metricKey === "rainfall");
      rows.push([
        ...(rainfallMetric ? [{ key: "rainfall", type: "metric", metric: rainfallMetric, chartKey: "rainfall" }] : []),
        { key: "deltaT", type: "deltaT", chartKey: "temperature" },
      ]);
      // Remaining metrics in pairs
      const remaining = this.remainingMetrics;
      for (let i = 0; i < remaining.length; i += 2) {
        const row = [];
        row.push({ key: remaining[i].metricKey, type: "metric", metric: remaining[i], chartKey: chartMap[remaining[i].metricKey] || "temperature" });
        if (i + 1 < remaining.length) {
          row.push({ key: remaining[i + 1].metricKey, type: "metric", metric: remaining[i + 1], chartKey: chartMap[remaining[i + 1].metricKey] || "temperature" });
        }
        rows.push(row);
      }
      return rows;
    },
    tableColumns() {
      if (SONDA_LINKNAMES.includes(this.station.linkname)) {
        return [
          { key: "hora", label: "hora", format: "time", width: "25%" },
          { key: "depthCalc", label: "profundidade (m)", decimals: 2 },
        ];
      }
      return [
        { key: "hora", label: "hora", format: "time", width: "22%" },
        { key: "min", label: "mínima", formatter: (row) => { const field = this.selectedMetricKey; return row[field] != null ? this.formatVal(row[field]) : "--"; } },
        { key: "avg", label: "média", formatter: (row) => { const field = this.selectedMetricKey; return row[field] != null ? this.formatVal(row[field]) : "--"; } },
        { key: "max", label: "máxima", formatter: (row) => { const field = this.selectedMetricKey; return row[field] != null ? this.formatVal(row[field]) : "--"; } },
      ];
    },
  },

  methods: {
    formatVal(v) { if (typeof v === "number") { return Number.isInteger(v) ? v : v.toFixed(2); } return v; },
    // Formato da caixa d'água inferido das dimensões da leitura (ver mixin/sondas.js).
    caixaFormato(sensor) {
      return caixaFormato(this.sondaLastHour(sensor));
    },
    caixaEhRedonda(sensor) {
      return this.caixaFormato(sensor) === CAIXA_REDONDA;
    },
    // % de enchimento (nível / altura) e volume em m³, derivados da geometria da leitura.
    caixaCapacidade(sensor) {
      return caixaCapacidade(this.sondaLastHour(sensor));
    },
    caixaVolume(sensor) {
      return caixaVolume(this.sondaLastHour(sensor));
    },
    // Forma usada só para desenhar (cai em redonda quando falta geometria).
    caixaFormatoDesenho(sensor) {
      return caixaFormatoDesenho(this.sondaLastHour(sensor));
    },
    caixaSemGeometria(sensor) {
      return caixaSemGeometria(this.sondaLastHour(sensor));
    },
    sondaLastHour(sensor) {
      if (!sensor || !sensor.hours || !sensor.hours.length) return null;
      return sensor.hours[sensor.hours.length - 1];
    },
    sondaMax(sensor, field) {
      if (!sensor || !sensor.hours) return null;
      const values = sensor.hours.map(h => h[field]).filter(v => v != null);
      return values.length ? Math.max(...values) : null;
    },
    sondaMin(sensor, field) {
      if (!sensor || !sensor.hours) return null;
      const values = sensor.hours.map(h => h[field]).filter(v => v != null);
      return values.length ? Math.min(...values) : null;
    },
    selectSondaCard(sourceId) {
      const key = 'sonda-' + sourceId;
      if (this.selectedCardKey === key) {
        this.selectedCardKey = null;
      } else {
        this.selectedCardKey = key;
        this.station.sourceId = sourceId;
        this.loadSensorStats();
      }
    },
    formatSourceId(id) { return (!id || id === 'default') ? 'Principal' : id; },
    formatDate(dt) { if (!dt) return "--"; return new Date(dt).toLocaleDateString("pt-BR"); },
    formatTime(dt) { if (!dt) return "--"; return new Date(dt).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }); },
    calcSensacao() { if (!this.hour) return "--"; const t = this.hour.temperature; const h = this.hour.humidity; if (t == null || h == null) return "--"; const hi = t + 0.5555 * (6.11 * Math.exp(5417.7530 * (1/273.16 - 1/(273.15 + (243.04 * Math.log(h/100)) / (17.625 - Math.log(h/100))))) * (h / 100) - 10); return Math.round(hi); },
    calcPontoOrvalhoRaw() { if (!this.hour) return null; const t = this.hour.temperature; const h = this.hour.humidity; if (t == null || h == null) return null; return t * Math.atan(0.151977 * Math.sqrt(h + 8.313659)) + Math.atan(t + h) - Math.atan(h - 1.676331) + 0.00391838 * Math.pow(h, 1.5) * Math.atan(0.023101 * h) - 4.686035; },
    calcPontoOrvalho() { const po = this.calcPontoOrvalhoRaw(); return po != null ? po.toFixed(1) : "N/D"; },
    calcBulboUmido() { if (!this.hour) return "N/D"; const t = this.hour.temperature; const h = this.hour.humidity; if (t == null || h == null) return "N/D"; const tw = t * Math.atan(0.151977 * Math.sqrt(h + 8.313659)) + Math.atan(t + h) - Math.atan(h - 1.676331) + 0.00391838 * Math.pow(h, 1.5) * Math.atan(0.023101 * h) - 4.686035; return ((t + tw) / 2).toFixed(1); },
    calcEvapotranspiracao() { if (!this.hour) return "N/D"; const tMax = this.currentDayResume.temperatureMax; const tMin = this.currentDayResume.temperatureMin; if (tMax == null || tMin == null) return "N/D"; const tMean = (tMax + tMin) / 2; const ra = 15; const et = 0.0023 * (tMean + 17.8) * Math.sqrt(tMax - tMin) * ra; return et.toFixed(1); },
    calcGeada() { const po = this.calcPontoOrvalhoRaw(); if (po == null) return "N/D"; return po.toFixed(1); },
    calculateDeltaT() {
      if (!this.info || this.expandedDayIndex === null) return;
      const hours = this.currentDayHours;
      if (!hours.length) return;
      const last = hours[hours.length - 1];
      const { temperature, humidity, windDirection, windSpeed, gustSpeed } = last;
      if (temperature == null || humidity == null) return;
      const pontoOrvalho = temperature * Math.atan(0.151977 * Math.sqrt(humidity + 8.313659)) + Math.atan(temperature + humidity) - Math.atan(humidity - 1.676331) + 0.00391838 * Math.pow(humidity, 1.5) * Math.atan(0.023101 * humidity) - 4.686035;
      const dt = temperature - pontoOrvalho;
      this.deltaT.value = dt.toFixed(2);
      this.deltaT.status = this.getAdequado(dt);
      this.deltaT.windDirection = windDirection || "N/A";
      this.deltaT.temperature = temperature;
      this.deltaT.windSpeed = windSpeed;
      this.deltaT.humidity = humidity;
      this.deltaT.gustSpeed = gustSpeed;
      this.updateDeltaTPoint();
    },
    updateDeltaTPoint() {
      if (!this.deltaT.temperature || !this.deltaT.humidity) return;
      // Imagem original 549x479, renderizada em 280x280
      // Eixo X (temperatura 0°-50°): na imagem original vai de ~45px a ~510px
      // Escalado para 280: 45*(280/549)=22.9 a 510*(280/549)=260.1 -> ~23 a 260
      // Eixo Y (umidade 10%-100%): na imagem original vai de ~445px(10%) a ~10px(100%)
      // Escalado para 280: 445*(280/479)=260.1 a 10*(280/479)=5.8 -> ~260(10%) a ~6(100%)
      const interpolar = (valor, minE, maxE, minS, maxS) => minS + (maxS - minS) * ((valor - minE) / (maxE - minE));
      this.deltaT.pointX = Math.max(23, Math.min(interpolar(this.deltaT.temperature, 0, 50, 23, 260), 260));
      this.deltaT.pointY = Math.max(6, Math.min(interpolar(this.deltaT.humidity, 10, 100, 260, 6), 260));
    },
    getAdequado(deltaT) { if (deltaT < 1) return "Ruim"; if (deltaT < 2) return "Regular"; if (deltaT < 10) return "Adequado"; if (deltaT < 12) return "Inadequado"; return "Ruim"; },
    getDeltaTColor() { if (!this.deltaT.status) return "#727272"; switch(this.deltaT.status) { case "Ruim": return "#f45a51"; case "Regular": return "#f9e862"; case "Inadequado": return "#fda700"; case "Adequado": return "#5eb965"; default: return "#727272"; } },
    getTemperatureColor() {
      if (!this.hour || this.hour.temperature == null) return "128,128,128";
      const valor = this.hour.temperature;
      let r, g, b;
      if (valor <= -30) { r = 149; g = 185; b = 217; }
      else if (valor <= -15) { const p = ((valor + 30) * 100) / 15; r = Math.round(149 - (149 * p) / 100); g = Math.round(185 - (104 * p) / 100); b = Math.round(217 - (44 * p) / 100); }
      else if (valor <= 5) { const p = ((valor + 15) * 100) / 20; r = 0; g = Math.round(81 + (127 * p) / 100); b = Math.round(173 - (85 * p) / 100); }
      else if (valor <= 15) { const p = ((valor - 5) * 100) / 10; r = Math.round(255 * p / 100); g = Math.round(208 - (73 * p) / 100); b = Math.round(88 - (88 * p) / 100); }
      else if (valor <= 30) { const p = ((valor - 15) * 100) / 15; r = Math.round(255 - (7 * p) / 100); g = Math.round(135 - (135 * p) / 100); b = 0; }
      else if (valor <= 40) { const p = ((valor - 30) * 100) / 10; r = Math.round(248 - (92 * p) / 100); g = 0; b = 0; }
      else if (valor <= 50) { const p = ((valor - 40) * 100) / 10; r = Math.round(156 - (31 * p) / 100); g = 0; b = 0; }
      else { r = 125; g = 0; b = 0; }
      return `${r},${g},${b}`;
    },
    directionAbbreviation(direction) { const map = { Leste: "L", Nordeste: "NE", Noroeste: "NO", Norte: "N", Oeste: "O", Sudoeste: "SO", Sul: "S", Suldeste: "SE" }; return map[direction] || "N/A"; },
    onDaySelect(index) { this.expandedDayIndex = index; },
    onMetricSelect(metricKey) { this.selectCard(metricKey); },
    switchTempTab(tab) {
      this.tempTab = tab;
    },
    switchWindTab(tab) {
      this.windTab = tab;
    },
    selectCard(cardKey, chartKey) {
      const chartMap = { temperatura: "temperature", vento: "windSpeed", sonda: "depthCalc", uvi: "uvi", solarRadiation: "solarRadiation", light: "light", pressureInHpa: "pressureInHpa", rainfall: "rainfall", deltaT: "temperature", windDirection: "windSpeed", bulboUmido: "temperature", evapotranspiracao: "temperature", geada: "temperature", pontoOrvalho: "temperature" };
      const resolvedChartKey = chartKey || chartMap[cardKey] || "temperature";
      if (this.selectedCardKey === cardKey) {
        this.selectedCardKey = null;
      } else {
        this.selectedCardKey = cardKey;
        this.selectedMetricKey = resolvedChartKey;
        if (cardKey === "temperatura") this.tempTab = "temperature";
        if (cardKey === "vento") this.windTab = "speed";
        if (this.station.linkname === "estacao") {
          this.loadHourlyStats();
        } else {
          this.loadSensorStats();
        }
      }
    },
    loadHourlyStats() {
      if (!this.info || this.expandedDayIndex === null || !this.qrCodeId) return;
      const day = this.info.days[this.expandedDayIndex];
      if (!day) return;

      const date = new Date(day.date).toISOString().split("T")[0];
      let url = `/Station/GetStationHourlyStats/${this.qrCodeId}/${this.station.linkname}?date=${date}`;

      const sensoresDoMesmoTipo = this.sensorList.filter((s) => s.linkname === this.station.linkname);
      if (sensoresDoMesmoTipo.length > 1) {
        url += `&hasSourceIdFilter=true`;
        if (this.station.sourceId != null) {
          url += `&sourceId=${this.station.sourceId}`;
        }
      }

      const requestId = ++this.statsRequestId;
      const ctx = this.contextKey();
      const isCurrent = () => requestId === this.statsRequestId && ctx === this.contextKey();
      this.loadingStats = true;
      this.urlGet(url)
        .then((e) => {
          if (isCurrent()) this.hourlyStats = e.data;
        })
        .catch(() => {
          if (isCurrent()) this.hourlyStats = null;
        })
        .finally(() => {
          if (requestId === this.statsRequestId) this.loadingStats = false;
        });
    },
    loadSensorStats() {
      if (!this.info || this.expandedDayIndex === null || !this.qrCodeId) return;
      const day = this.info.days[this.expandedDayIndex];
      if (!day) return;

      const date = new Date(day.date).toISOString().split("T")[0];
      let url = `/Station/GetSensorStats/${this.qrCodeId}/${this.station.linkname}?date=${date}`;

      // Extrair sourceId do selectedCardKey (ex: "solo-default" → "default")
      let sourceId = this.station.sourceId;
      if (this.selectedCardKey && this.selectedCardKey.includes('-')) {
        const parts = this.selectedCardKey.split('-');
        const possibleSourceId = parts.slice(1).join('-');
        if (possibleSourceId && possibleSourceId !== 'hidrostatica' && possibleSourceId !== 'laser' && possibleSourceId !== 'nivel') {
          sourceId = possibleSourceId;
        }
      }

      if (sourceId) {
        url += `&hasSourceIdFilter=true&sourceId=${sourceId}`;
      }

      const requestId = ++this.statsRequestId;
      const ctx = this.contextKey();
      const isCurrent = () => requestId === this.statsRequestId && ctx === this.contextKey();
      this.loadingStats = true;
      this.sensorStats = null;
      this.urlGet(url)
        .then((e) => { if (isCurrent()) this.sensorStats = e.data; })
        .catch(() => { if (isCurrent()) this.sensorStats = null; })
        .finally(() => { if (requestId === this.statsRequestId) this.loadingStats = false; });
    },
    selectSensorCard(type, sourceId, tab) {
      const key = type + '-' + sourceId;
      if (this.selectedCardKey === key && this.soilTab === tab) {
        this.selectedCardKey = null;
      } else {
        this.selectedCardKey = key;
        this.soilTab = tab || 'temperature';
        this.loadSensorStats();
      }
    },
    selectedGenericSensor(type, sensors) {
      if (!this.selectedCardKey || !this.selectedCardKey.startsWith(type + '-')) return null;
      const sourceId = this.selectedCardKey.replace(type + '-', '');
      return sensors.find(s => s.sourceId === sourceId) || null;
    },
    selectSoilCard(sourceId, tab) {
      const key = 'solo-' + sourceId;
      if (this.selectedCardKey === key && this.soilTab === tab) {
        this.selectedCardKey = null;
      } else {
        this.selectedCardKey = key;
        this.soilTab = tab || 'temperature';
        this.loadSensorStats();
      }
    },
    soilChartData(field) {
      if (!this.selectedSoilSensor) return [];
      return this.selectedSoilSensor.hours.map(h => ({
        dateTime: h.dateTimeLeitura || h.dateTime,
        avg: h[field] ?? 0,
        temperature: h.temperature ?? 0,
        humidity: h.humidity ?? 0,
      }));
    },
    calcSensacaoSensor(sensor) {
      const last = this.soilLastHour(sensor);
      if (!last) return "--";
      const t = last.temperature;
      const h = last.humidity;
      if (t == null || h == null) return "--";
      const hi = t + 0.5555 * (6.11 * Math.exp(5417.7530 * (1/273.16 - 1/(273.15 + (243.04 * Math.log(h/100)) / (17.625 - Math.log(h/100))))) * (h / 100) - 10);
      return Math.round(hi);
    },
    getSoilTemperatureColor(sensor) {
      const last = this.soilLastHour(sensor);
      return this.temperatureRgb(last ? last.temperature : null);
    },
    // Escala de cor da temperatura ("r,g,b"), cinza quando não há valor.
    temperatureRgb(valor) {
      if (valor == null) return "128,128,128";
      let r, g, b;
      if (valor <= -30) { r = 149; g = 185; b = 217; }
      else if (valor <= -15) { const p = ((valor + 30) * 100) / 15; r = Math.round(149 - (149 * p) / 100); g = Math.round(185 - (104 * p) / 100); b = Math.round(217 - (44 * p) / 100); }
      else if (valor <= 5) { const p = ((valor + 15) * 100) / 20; r = 0; g = Math.round(81 + (127 * p) / 100); b = Math.round(173 - (85 * p) / 100); }
      else if (valor <= 15) { const p = ((valor - 5) * 100) / 10; r = Math.round(255 * p / 100); g = Math.round(208 - (73 * p) / 100); b = Math.round(88 - (88 * p) / 100); }
      else if (valor <= 30) { const p = ((valor - 15) * 100) / 15; r = Math.round(255 - (7 * p) / 100); g = Math.round(135 - (135 * p) / 100); b = 0; }
      else if (valor <= 40) { const p = ((valor - 30) * 100) / 10; r = Math.round(248 - (92 * p) / 100); g = 0; b = 0; }
      else if (valor <= 50) { const p = ((valor - 40) * 100) / 10; r = Math.round(156 - (31 * p) / 100); g = 0; b = 0; }
      else { r = 125; g = 0; b = 0; }
      return `${r},${g},${b}`;
    },
    loadGruposComparacao(qrCodeId) {
      this.gruposComparacao = [];
      this.urlGet(`/GrupoComparacao/Dispositivo/${qrCodeId}`)
        .then((e) => {
          // Descarta resposta atrasada de outro pin aberto antes.
          if (this.qrCodeId !== qrCodeId) return;
          this.gruposComparacao = (e.data || []).filter((g) => (g.dispositivos || []).length > 1);
        })
        .catch(() => { this.gruposComparacao = []; });
    },
    comparacaoLink(grupo) {
      const params = new URLSearchParams({ grupo: grupo.id });
      const day = this.info && this.expandedDayIndex !== null ? this.info.days[this.expandedDayIndex] : null;
      if (day && day.date) params.append('date', new Date(day.date).toISOString().split('T')[0]);
      if (this.qrCodeId != null) params.append('dispositivo', this.qrCodeId);
      return `/comparacao?${params.toString()}`;
    },
    isFotobioSelected(field) {
      return this.selectedCardKey === 'fotobio-' + this.fotobioSourceId && this.soilTab === field;
    },
    isRitterSelected(tab) {
      return this.selectedCardKey === 'ritter-' + this.ritterSourceId && this.soilTab === tab;
    },
    formatLitros(v) {
      if (v == null) return '--';
      return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    // Vazões pequenas (medidor de 0,5 L em L/min) somem com 2 casas.
    formatVazaoNumero(v) {
      if (v == null || isNaN(v)) return '--';
      const casas = Math.abs(v) > 0 && Math.abs(v) < 1 ? 3 : 2;
      return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
    },
    formatVazao(v) {
      return v == null ? '--' : this.formatVazaoNumero(v * this.ritterFlowFactor);
    },
    soilLastHour(sensor) {
      if (!sensor.hours.length) return null;
      return sensor.hours[sensor.hours.length - 1];
    },
    sensorHasHumidity(sensor) {
      return sensor.hours.some(h => h.humidity != null);
    },
    // Máx/mín do dia por sensor vem do resumo (todas as leituras). As horas trazem só a
    // última leitura de cada hora: calcular em cima delas perdia extremos que a tabela
    // por hora mostrava. As horas ficam só de reserva.
    soilResumoCampo(sensor, field) {
      const s = (this.currentDayResume.sensores || []).find(x => x.sourceId === sensor.sourceId);
      return s ? s.campos.find(c => c.field === field) || null : null;
    },
    soilMax(sensor, field) {
      const r = this.soilResumoCampo(sensor, field);
      if (r) return r.max;
      const values = sensor.hours.map(h => h[field]).filter(v => v != null);
      return values.length ? Math.max(...values) : null;
    },
    soilMin(sensor, field) {
      const r = this.soilResumoCampo(sensor, field);
      if (r) return r.min;
      const values = sensor.hours.map(h => h[field]).filter(v => v != null);
      return values.length ? Math.min(...values) : null;
    },
    isRowSelected(row) {
      return row.some(card => {
        const key = card.key || (card.metric && card.metric.metricKey);
        return key === this.selectedCardKey;
      });
    },
    // Identifica dispositivo + sensor. Resposta assíncrona só é aplicada se o contexto em que
    // foi pedida ainda for o aberto — o aside nunca mostra dado de outro dispositivo/sensor.
    contextKey(qrCodeId = this.qrCodeId, linkname = this.station.linkname, sourceId = this.station.sourceId) { return `${qrCodeId}|${linkname}|${sourceId ?? ""}`; },
    async loadSensors(qrCodeId) { try { const response = await this.urlPost(`/Station/GetSensorByQrCodeId/${qrCodeId}`); if (this.qrCodeId !== qrCodeId) return; this.sensorList = response.data.itens || []; if (this.sensorList.length > 0) { this.selectedSensorIndex = 0; this.updateStationFromSensor(this.sensorList[0]); } } catch (error) { if (this.qrCodeId === qrCodeId) this.sensorList = []; } },
    updateStationFromSensor(sensor) { this.station.nome = sensor.nome; this.station.linkname = sensor.linkname; this.station.sourceId = sensor.sourceId; },
    onSensorChange() { const sensor = this.sensorList[this.selectedSensorIndex]; if (sensor) { this.updateStationFromSensor(sensor); this.setLoadBySensor(this.qrCodeId); } },
    // Ícone (SVG) do tipo de sensor; null se não houver (mostra só o nome).
    sensorIcon(linkname) { return SENSOR_ICONS[(linkname || "").toLowerCase()] || null; },
    // Dropdown customizado de sensores (o <select> nativo não aceita ícones).
    toggleSensorDropdown() { this.sensorDropdownOpen = !this.sensorDropdownOpen; },
    selectSensor(index) {
      this.sensorDropdownOpen = false;
      if (index === this.selectedSensorIndex) return;
      this.selectedSensorIndex = index;
      this.onSensorChange();
    },
    getDataFirstRender(estacaoId, data) { this.qrCodeId = estacaoId; clearTimeout(this.next); this.dataRequestId++; this.statsRequestId++; this.info = null; this.expandedDayIndex = null; this.sensorList = []; this.hourlyStats = null; this.sensorStats = null; this.load = true; this.loadGruposComparacao(estacaoId); this.loadSensors(estacaoId).then(() => { if (this.qrCodeId !== estacaoId) return; if (this.sensorList.length === 0) { this.load = false; return; } const initialIndex = this.pickInitialSensorIndex(this.sensorList); this.selectedSensorIndex = initialIndex; this.updateStationFromSensor(this.sensorList[initialIndex]); this.setLoadBySensor(estacaoId); }); },
    // Escolhe o sensor com a leitura mais recente (lastReadingAt). Em empate, prefere 'estacao'.
    // Fallback: se nenhum sensor tem lastReadingAt, mantém o comportamento legado (estacao, senão [0]).
    pickInitialSensorIndex(list) { let bestIndex = -1; let bestTime = -Infinity; for (let i = 0; i < list.length; i++) { const raw = list[i].lastReadingAt; if (!raw) continue; const t = new Date(raw).getTime(); if (isNaN(t)) continue; if (t > bestTime || (t === bestTime && list[i].linkname === "estacao")) { bestTime = t; bestIndex = i; } } if (bestIndex >= 0) return bestIndex; const estacaoIndex = list.findIndex((s) => s.linkname === "estacao"); return estacaoIndex >= 0 ? estacaoIndex : 0; },
    getData(estacaoId, data) { clearTimeout(this.next); this.data = data; this.load = true; this.next = setTimeout(() => { this.info = null; this.expandedDayIndex = null; let url = `/Station/GetStationById/${estacaoId}/${this.station.linkname}`; const params = new URLSearchParams(); const sensoresDoMesmoTipo = this.sensorList.filter((s) => s.linkname === this.station.linkname); if (sensoresDoMesmoTipo.length > 1 && !['solo', 'folhar', 'ambiente', 'lut'].includes(this.station.linkname)) { params.append("hasSourceIdFilter", "true"); if (this.station.sourceId != null) { params.append("sourceId", this.station.sourceId); } } if (params.toString()) { url += `?${params.toString()}`; } const requestId = ++this.dataRequestId; const ctx = this.contextKey(estacaoId); this.urlGet(url).then((e) => { if (requestId !== this.dataRequestId || ctx !== this.contextKey()) return; this.info = e.data; this.premium = e.data.premium; const now = new Date().getDate(); for (let i = 0; i < this.info.days.length; i++) { const d = new Date(this.info.days[i].date).getDate(); if (d === now) { this.expandedDayIndex = i; break; } } if (this.expandedDayIndex === null) { this.expandedDayIndex = this.info.days.length - 1; } this.calculateDeltaT(); }).catch(() => {}).finally(() => { if (requestId === this.dataRequestId) this.load = false; }); }, 300); },
    setLoadBySensor(estacaoId = this.qrCodeId) { this.$nextTick(() => { switch (this.station.linkname) { case "estacao": this.getData(estacaoId); break; case "sonda-hidrostatica": case "sonda-laser": case "sonda-nivel": case "sonda-caixa": this.selectedMetricKey = "depthCalc"; this.getData(estacaoId); break; case "solo": case "folhar": case "ambiente": case "lut": case "fotobio": case "ritter": this.getData(estacaoId); break; case "chuva": case "energia": case "energia-smtp": case "piranometro": this.info = null; this.expandedDayIndex = null; this.load = false; break; default: this.getData(estacaoId); break; } }); },
  },

  watch: {
    expandedDayIndex(val) {
      this.selectedCardKey = null;
      this.hourlyStats = null;
      this.statsRequestId++;
      if (val !== null) {
        this.calculateDeltaT();
      }
    },
  },
};
</script>

<style scoped>
.na-sensor-select {
  padding: 0 4px 8px;
}

/* ===== Dropdown customizado de sensores (ícone + nome) ===== */
.na-sensor-dropdown {
  position: relative;
}
.na-sensor-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10;
}
.na-sensor-trigger {
  position: relative;
  z-index: 11;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  text-align: left;
}
.na-sensor-trigger-content {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.na-sensor-chevron {
  font-size: 12px;
  color: #888;
  transition: transform 0.18s ease;
  flex: 0 0 auto;
}
.na-sensor-dropdown.open .na-sensor-chevron {
  transform: rotate(180deg);
}
.na-sensor-options {
  position: absolute;
  z-index: 12;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 4px;
  list-style: none;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  box-shadow: 0 8px 20px -6px rgba(0, 0, 0, 0.25);
  max-height: 280px;
  overflow-y: auto;
}
.na-sensor-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.na-sensor-option:hover {
  background: #f2f4f7;
}
.na-sensor-option.selected {
  background: #eaf3ea;
  font-weight: 600;
}
.na-sensor-opt-icon {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
}
.na-sensor-opt-icon--empty {
  display: inline-block;
}

.na-section {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 8px;
}

.na-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.na-historico-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 4px;
}

.na-historico-title {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.na-sensor-icons {
  display: flex;
  gap: 4px;
  align-items: center;
}

.na-battery-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.na-onconnect-battery-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.na-onconnect-battery-icon--header {
  width: 32px;
  height: 16px;
  color: #393939;
}

.na-onconnect-battery-icon--tooltip {
  width: 26px;
  height: 13px;
}

.na-onconnect-battery-text {
  position: absolute;
  font-size: 9px;
  font-weight: 700;
  pointer-events: none;
}

.na-onconnect-battery-icon--header .na-onconnect-battery-text {
  color: #333;
}

.na-onconnect-battery-icon--tooltip .na-onconnect-battery-text {
  color: #fff;
  font-size: 7px;
}

.na-battery-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  right: -8px;
  background: #2C3E1E;
  color: #fff;
  border-radius: 8px;
  border: 1px solid #4a6634;
  padding: 8px 10px;
  z-index: 100;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
}

.na-battery-tooltip::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 10px;
  height: 10px;
  background: #2C3E1E;
  border-top: 1px solid #4a6634;
  border-left: 1px solid #4a6634;
  transform: rotate(45deg);
}

.na-btt-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.na-btt-icons-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.na-btt-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

.na-btt-icon-white {
  filter: brightness(0) invert(1);
}

.na-btt-label {
  font-size: 10px;
  color: #ccc;
}

.na-btt-battery {
  width: 24px;
  height: 26px;
  flex-shrink: 0;
}

.na-btt-battery-white {
  color: #FFFFFF;
}


/* Sensor Solo */
.na-soil-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 8px;
}

.na-soil-depth-label {
  display: inline-flex;
  gap: 4px;
  font-size: 13px;
  color: #333;
  background: #F2F2F2;
  padding: 4px 10px;
  border-radius: 20px;
  width: fit-content;
}

.na-soil-cards-row {
  display: flex;
  gap: 6px;
}

.na-soil-card-half {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  padding: 6px 4px;
}

.na-soil-card-half .na-temp-body {
  gap: 4px;
}

/* ===== Fotobio (tanques) e Ritter ===== */
/* Gráfico aberto entre um card e o próximo */
.na-fotobio-chart {
  margin-bottom: 8px;
}
/* Borda transparente reserva o espaço da borda de selecionado (sem pular layout). */
.na-fotobio-card {
  border: 1px solid transparent;
}
.na-fotobio-card .na-temp-header {
  margin-bottom: 6px;
}
.na-fotobio-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.na-fotobio-empty {
  font-size: 13px;
  color: #777;
  text-align: center;
}
.na-chart-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #333;
}
.na-chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.na-ritter-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.na-ritter-unit {
  display: inline-flex;
  background: #F2F2F2;
  border-radius: 20px;
  padding: 2px;
}
.na-ritter-unit button {
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 3px 10px;
  border-radius: 20px;
  cursor: pointer;
}
.na-ritter-unit button.active {
  background: #006035;
  color: #fff;
}
.na-ritter-body small,
.na-fotobio-card small {
  font-size: 12px;
  font-weight: 600;
}
.na-ritter-flow {
  justify-content: space-around;
  text-align: center;
}
.na-ritter-flow-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}
.na-ritter-flow-col .na-soil-temp-value {
  font-size: 20px;
}

.na-soil-card-half .na-temp-mid {
  padding: 0;
}

.na-soil-temp-value {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.na-soil-temp-value sup {
  font-size: 13px;
}

.na-soil-sensacao {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 13px;
  color: #313C30;
  background: #E8F8E6;
  padding: 6px 14px;
  border-radius: 20px;
  width: fit-content;
  margin: 0 auto;
}

.na-days-container {
  position: relative;
}

.na-days-row {
  display: flex;
  overflow-x: auto;
  gap: 3px;
  padding: 0;
  position: relative;
  z-index: 2;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.na-days-row::-webkit-scrollbar {
  display: none;
}

.na-expanded-content {
  border: 1px solid #C3D9AD;
  border-radius: 10px;
  background: #FFFFFF80;
  padding: 10px;
  position: relative;
  z-index: 1;
  margin-top: 0;
  animation: na-expand 0.3s ease-out;
}

@keyframes na-expand {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Common icon size */
.na-icon-20 {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* Astronomia */
.na-astronomia {
  padding: 8px 10px;
}

.na-astro-label {
  font-size: 12px;
  color: #333;
  margin-bottom: 8px;
}

.na-astro-row {
  display: flex;
  justify-content: space-between;
}

.na-astro-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.na-astro-sun {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,240,0,0.8) 30%, rgba(255,239,66,0.5) 60%, rgba(255,248,0,0) 100%);
  flex-shrink: 0;
}

.na-astro-moon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.95) 40%, rgba(234,234,234,0.6) 100%);
  border: 1px solid #eaeaea;
  flex-shrink: 0;
}
img.na-astro-moon {
  background: none;
  border: none;
  border-radius: 0;
  object-fit: contain;
}

.na-astro-info {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #333;
  line-height: 1.3;
}

.na-astro-info b {
  font-size: 12px;
  color: #333;
}

.na-astro-info span {
  font-size: 11px;
  color: #666;
}

/* Leitura atual */
.na-leitura {
  padding: 6px 12px;
}

.na-leitura-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.na-leitura-label {
  font-weight: 600;
  font-size: 12px;
  color: #333;
}

.na-leitura-date {
  font-size: 12px;
  color: #333;
}

.na-leitura-time {
  font-size: 12px;
  font-weight: 400;
  color: #006035;
}

/* Common icon sizes */
.na-icon-18 {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.na-icon-24 {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* Em breve card */
.na-coming-soon-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  text-align: center;
  gap: 8px;
}

.na-coming-soon-icon {
  opacity: 0.6;
}

.na-coming-soon-title {
  font-size: 16px;
  font-weight: 700;
  color: #90A4AE;
}

.na-coming-soon-text {
  font-size: 12px;
  color: #B0BEC5;
  line-height: 1.4;
  max-width: 240px;
}

/* Sonda badge */
.na-sonda-badge-row {
  padding: 0 0 4px;
}

.na-sonda-badge {
  display: inline-block;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Hidro referencia badge */
.na-hidro-ref-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  padding: 6px 14px;
  border-radius: 20px;
  width: fit-content;
  margin: 6px auto 0;
}

.na-hidro-ref-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Laser details */
.na-laser-details {
  display: flex;
  justify-content: space-around;
  padding: 6px 8px 2px;
  gap: 8px;
}

.na-laser-details span {
  font-size: 11px;
  color: #888;
}

.na-laser-details b {
  color: #333;
}

/* Caixa d'água: desenho do reservatório + métricas */
.na-caixa-desenho {
  display: flex;
  justify-content: center;
  padding: 10px 8px 4px;
}

.na-caixa-metricas {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 4px 8px 8px;
  gap: 8px;
}

.na-caixa-metrica {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 1;
}

.na-caixa-metrica-label {
  font-size: 12px;
  color: #888;
}

.na-caixa-metrica-valor {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
}

.na-caixa-metrica-valor small {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-left: 1px;
}

.na-caixa-aviso {
  padding: 2px 10px 6px;
  text-align: center;
  font-size: 10.5px;
  line-height: 1.3;
  color: #a08b3a;
}

/* Nivel card */
.na-sonda-logo-row {
  display: flex;
  justify-content: flex-end;
  padding: 6px 2px 0;
}

.na-sonda-logo {
  width: 75px;
  height: 20px;
  display: block;
}

.na-estacao-logo-row {
  display: flex;
  justify-content: center;
  padding: 4px 0 8px;
}

.na-estacao-logo {
  width: 75px;
  height: 20px;
  display: block;
}

.na-chart-table-logo {
  display: flex;
  justify-content: center;
  padding: 6px 0 0;
}

.na-chart-table-logo img {
  width: 75px;
  height: 20px;
  display: block;
}

.na-nivel-image-wrapper {
  display: flex;
  justify-content: center;
  padding: 12px 0 8px;
}

.na-nivel-image {
  width: 100%;
  max-width: 280px;
  max-height: 174px;
  height: auto;
  object-fit: contain;
}

.na-nivel-transbordo-row {
  text-align: center;
}

.na-nivel-transbordo-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F2F2F2;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  color: #555;
  font-weight: 500;
}

.na-nivel-transbordo-badge b {
  color: #333;
  font-weight: 700;
}

.na-nivel-transbordo-x {
  color: #78A64E;
  font-size: 13px;
  font-weight: 700;
  font-style: italic;
}

/* Temperatura card */
.na-temp-card {
  padding: 10px;
}

.na-temp-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #333;
}

.na-temp-header img {
  filter: brightness(0);
}

.na-temp-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 8px;
}

.na-temp-left {
  flex-shrink: 0;
}

.na-temp-value {
  font-size: 38px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}

.na-temp-value sup {
  font-size: 20px;
}

.na-temp-mid {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
}

.na-temp-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.na-temp-umidade-label {
  display: flex;
  align-items: center;
  gap: 3px;
}

.na-icon-14 {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.na-temp-info-label {
  font-size: 12px;
  color: #999;
  line-height: 20px;
}

.na-temp-info-value {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 20px;
}

/* Vento card */
.na-wind-card {
  padding: 10px;
}

.na-wind-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #333;
}

.na-wind-header img {
  filter: brightness(0);
}

.na-wind-body {
  display: flex;
  align-items: stretch;
}

.na-wind-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;
}

.na-wind-dir-top {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
  min-height: 24px;
}

.na-wind-label {
  font-size: 13px;
  color: #666;
  line-height: 24px;
}

.na-wind-value-lg {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  text-align: center;
  line-height: 22px;
}

/* Delta T + Direção do Vento row */
.na-dt-dir-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

/* Delta T card */
.na-dt-card {
  flex: 1;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.na-dt-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.na-dt-header {
  display: flex;
  align-items: center;
  gap: 5px;
}

.na-dt-icon {
  filter: brightness(0);
}

.na-dt-label {
  font-size: 12px;
  color: #333;
}

.na-dt-bar {
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(90deg, #FF0000 8%, #FFEA00 19%, #FFEA00 41%, #2EA625 47%, #199F28 62%, #1EA127 78%, #FFEA00 90%);
}

.na-dt-values {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.na-dt-number {
  font-size: 14px;
  color: #333;
}

.na-dt-status {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

/* Direção do Vento card */
.na-dir-card {
  flex: 1;
  background: radial-gradient(ellipse at 0% 100%, rgba(153, 82, 0, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), #fff;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.na-dir-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.na-dir-header {
  display: flex;
  align-items: center;
  gap: 5px;
}

.na-dir-header img {
  filter: brightness(0);
}

.na-dir-label {
  font-size: 12px;
  color: #333;
  line-height: 1.2;
}

.na-dir-value {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.na-dir-value b {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

/* Clickable cards */
.na-clickable {
  cursor: pointer;
  transition: box-shadow 0.2s, border-color 0.2s, background-color 0.2s;
}

.na-clickable:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Selected card state */
.na-card-selected {
  background: #EFF3FF !important;
  border: 1px solid #BBD1FF !important;
}

/* Chart + Table container with selected style */
.na-chart-table-card {
  background: #EFF3FF;
  border: 1px solid #BBD1FF;
  border-radius: 10px;
  padding: 10px;
}

.na-loading-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-height: 100px;
}

/* Delta T visualization */
.na-deltat-viz {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 8px;
}

.na-deltat-viz > div:last-child {
  padding: 0 12px 12px;
}

.na-deltat-grid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  user-select: none;
}

.na-deltat-grid-title {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.na-deltat-grid-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.na-deltat-grid-date {
  font-size: 12px;
  color: #666;
}

.na-deltat-grid-time {
  font-size: 12px;
  color: #666;
}

.na-deltat-grid-header .na-arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.3s;
}

.na-deltat-grid-header .na-arrow.collapsed {
  transform: rotate(-90deg);
}

.na-deltat-image-center {
  display: flex;
  justify-content: center;
  padding: 0 5px;
}

.na-deltat-image-wrapper {
  position: relative;
  display: inline-block;
  width: 280px;
  height: 280px;
}

.na-deltat-image-wrapper > img {
  width: 280px;
  height: 280px;
  display: block;
}

.na-deltat-point {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  overflow: hidden;
}

.na-deltat-point img {
  width: 100%;
  height: 100%;
}

.na-deltat-info {
  text-align: center;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.na-deltat-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.na-deltat-status {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.na-deltat-wind-dir {
  font-size: 14px;
  color: #666;
}

.na-deltat-icons-row {
  display: flex;
  justify-content: space-around;
  margin-top: 8px;
}

.na-deltat-icon-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #333;
}

/* Info card (Ponto de Orvalho, Evapotranspiração) */
.na-info-card {
  padding: 4px;
}

.na-info-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
}

.na-info-card p {
  font-size: 12px;
  color: #555;
  line-height: 1.5;
  margin: 0 0 8px 0;
}

.na-info-current {
  margin-top: 12px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.na-info-current b {
  font-size: 18px;
  color: #006035;
}

/* Wind tabs */
.na-wind-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
}

.na-wind-tab {
  flex: 1;
  padding: 8px;
  border: none;
  border-radius: 8px;
  background: #e8e8e8;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.na-wind-tab.active {
  background: #006035;
  color: #fff;
}

.na-wind-tab:hover:not(.active) {
  background: #d5d5d5;
}

/* Metrics Grid */
.na-metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}

/* Report button */
.na-report-container {
  text-align: center;
  margin-top: 8px;
  margin-bottom: 8px;
}

.na-btn-report {
  display: block;
  background-color: #78A64E;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s;
}

.na-btn-report:hover {
  background-color: #6a9443;
  color: #fff;
}

.na-btn-alert {
  display: block;
  background-color: #006035;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s;
}

.na-btn-compare {
  display: block;
  background-color: #fff;
  color: #006035;
  border: 1px solid #006035;
  border-radius: 10px;
  padding: 11px;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s;
}
.na-btn-compare + .na-btn-compare {
  margin-top: 8px;
}
.na-btn-compare:hover {
  background-color: #E8F8E6;
  color: #006035;
}

.na-btn-alert:hover {
  background-color: #004d29;
  color: #fff;
}

.na-premium-wrapper {
  padding: 0 4px 8px;
}
.na-premium-link {
  display: block;
  width: 100%;
}
.na-premium-link img {
  width: 100%;
  display: block;
}
</style>
